function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) }), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; defineProperty(this, "_invoke", { value: function value(method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; } function maybeInvokeDelegate(delegate, context) { var methodName = context.method, method = delegate.iterator[methodName]; if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator["return"] && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel; var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), defineProperty(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (val) { var object = Object(val), keys = []; for (var key in object) keys.push(key); return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, "catch": function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import { UI, DEFAULT_FONT, BuilderIcon } from "../builderUiTheme";
import Toolbar from "./components/Toolbar";
import Sidebar from "./components/Sidebar";
import Canvas from "./components/Canvas";
import PropertiesPanel from "./components/PropertiesPanel";
import { blocks, contentBlocks, extendedBlocks, layoutBlocks, LEFT_SIDEBAR_TABS, COMPLEX_BLOCK_TYPES, SPACING_SIDES, RADIUS_CORNERS, SPACING_SLIDER_MAX, SPACING_INPUT_MAX, RADIUS_SLIDER_MAX, RADIUS_INPUT_MAX, GOOGLE_FONTS, IMAGE_PLACEHOLDER_SRC } from "./constants/defaultBlocks";
import { sectionTemplates, pageTemplates } from "./constants/templates";

// Side panels shrink on smaller screens so the canvas keeps as much room as possible.
// The blocks sidebar stays narrower than the properties panel — its cards are fluid,
// while the properties fields need the extra room.
var SIDE_PANEL_MAX_WIDTH = 320;
function resolveSidePanelWidth(viewportWidth) {
  if (viewportWidth >= 1560) return SIDE_PANEL_MAX_WIDTH;
  if (viewportWidth >= 1366) return 296;
  return 272;
}
function resolveLeftSidebarWidth(viewportWidth) {
  if (viewportWidth >= 1560) return 288;
  if (viewportWidth >= 1366) return 264;
  return 244;
}
function readEmbeddedBuilderTemplates() {
  if (typeof document === "undefined") {
    return [];
  }
  var el = document.getElementById("new-builder-templates");
  if (!el) {
    return [];
  }
  try {
    var parsed = JSON.parse(el.textContent || "[]");
    if (Array.isArray(parsed)) {
      return parsed;
    }
    if (Array.isArray(parsed.templates)) {
      return parsed.templates;
    }
  } catch (e) {
    return [];
  }
  return [];
}
import { cloneBlockContent, cloneBlockNode, createUniqueBlockId, defaultBlockStyle, parsePxValue, parsePxFromShorthand, parseCssLength, getSpacingSideValue, getRadiusCornerLength, formatCssLength, hasIndividualSpacing, liftElementSpacingToBlock, hasIndividualRadius, getBackgroundImageUrl, escapeHtml, nl2br, getSocialIconSvgHtml, buildSocialExportHtml, getTreeFontFamily, resolveNodeFontFamily, isSingleWeightFont, resolveFontWeight, pdfFontCss, pdfTextWeight, buildExportStyleCss, exportFontOnly, buildPdfFontStyle, buildPdfWrapperStyle, renderPdfFloatColumns, gradientToSolid, extractBackgroundImageUrl, buildPdfStyleStr, pdfAlignFromStyle, buildPdfButtonHtml, getEmojiUrl, generateHtml, buildSignedSignatureHtml, getTableColumnCount, getTableElementStyle, getTableElementCss, sanitizeBuilderTree, findNodeRecursive, updateNodeInTree, removeNodeFromTree, mapNodesRecursive, isNestedColumnContent, isColumnLayoutType, getColumnLayoutType, MIN_LAYOUT_COLUMNS, MAX_LAYOUT_COLUMNS, mapColumnStyleArrays, ensureColumnStyleArray, ensureGoogleFontLoaded, collectTreeFontFamilies, withDefaultNewBlockMargin, DEFAULT_BACKGROUND_OVERLAY_OPACITY } from "./utils/helpers";
import { buildPdfFilename, filenameFromContentDisposition } from "../../lib/pdfDownloadFilename";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var EMPTY_DROP_POS = {
  parentId: null,
  columnIndex: null,
  index: null,
  blockId: null
};
var safeStorageGet = function safeStorageGet(key) {
  var fallback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
  try {
    return localStorage.getItem(key) || fallback;
  } catch (_unused) {
    return fallback;
  }
};
var isNestedColumnLayout = function isNestedColumnLayout(columns) {
  return Array.isArray(columns) && columns.length > 0 && Array.isArray(columns[0]);
};
var findNodeLocation = function findNodeLocation(nodes, nodeId) {
  var parentId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  var columnIndex = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
  for (var i = 0; i < nodes.length; i++) {
    var _nodes$i$content;
    if (nodes[i].id === nodeId) {
      return {
        parentId: parentId,
        columnIndex: columnIndex,
        index: i
      };
    }
    var columns = (_nodes$i$content = nodes[i].content) === null || _nodes$i$content === void 0 ? void 0 : _nodes$i$content.columns;
    if (isNestedColumnLayout(columns)) {
      for (var c = 0; c < columns.length; c++) {
        var found = findNodeLocation(columns[c], nodeId, nodes[i].id, c);
        if (found) return found;
      }
    }
  }
  return null;
};

/** Walk every column list (supports columns nested inside columns). */
var mapNestedColumnLists = function mapNestedColumnLists(nodes, mapper) {
  var changed = false;
  var next = (nodes || []).map(function (node) {
    var _node$content;
    var columns = (_node$content = node.content) === null || _node$content === void 0 ? void 0 : _node$content.columns;
    if (!isNestedColumnLayout(columns)) return node;
    var colsChanged = false;
    var nextCols = columns.map(function (col) {
      var mapped = mapper(col);
      if (mapped !== col) colsChanged = true;
      return mapped;
    });
    if (!colsChanged) return node;
    changed = true;
    return _objectSpread(_objectSpread({}, node), {}, {
      content: _objectSpread(_objectSpread({}, node.content), {}, {
        columns: nextCols
      })
    });
  });
  return changed ? next : nodes;
};
var getNodeAt = function getNodeAt(nodes, parentId, columnIndex, index) {
  var _parent$content;
  if (parentId == null) return nodes[index];
  var parent = findNodeRecursive(nodes, parentId);
  return parent === null || parent === void 0 || (_parent$content = parent.content) === null || _parent$content === void 0 || (_parent$content = _parent$content.columns) === null || _parent$content === void 0 || (_parent$content = _parent$content[columnIndex]) === null || _parent$content === void 0 ? void 0 : _parent$content[index];
};
var isSameListTarget = function isSameListTarget(parentId, columnIndex, loc) {
  var _loc$parentId, _loc$columnIndex;
  if (!loc) return false;
  return ((_loc$parentId = loc.parentId) !== null && _loc$parentId !== void 0 ? _loc$parentId : null) === (parentId !== null && parentId !== void 0 ? parentId : null) && ((_loc$columnIndex = loc.columnIndex) !== null && _loc$columnIndex !== void 0 ? _loc$columnIndex : null) === (columnIndex !== null && columnIndex !== void 0 ? columnIndex : null);
};

/** True when targetId exists somewhere under block's nested columns. */
var isNodeInsideBlock = function isNodeInsideBlock(block, targetId) {
  var _block$content;
  if (!block || targetId == null) return false;
  var columns = (_block$content = block.content) === null || _block$content === void 0 ? void 0 : _block$content.columns;
  if (!isNestedColumnLayout(columns)) return false;
  for (var c = 0; c < columns.length; c++) {
    if (findNodeLocation(columns[c], targetId)) return true;
  }
  return false;
};
var removeNodeAt = function removeNodeAt(nodes, parentId, columnIndex, index) {
  if (parentId == null) {
    var _next = _toConsumableArray(nodes);
    _next.splice(index, 1);
    return _next;
  }
  var removed = false;
  var next = nodes.map(function (node) {
    if (node.id === parentId) {
      removed = true;
      var cols = _toConsumableArray(node.content.columns || []);
      var col = _toConsumableArray(cols[columnIndex] || []);
      col.splice(index, 1);
      cols[columnIndex] = col;
      return _objectSpread(_objectSpread({}, node), {}, {
        content: _objectSpread(_objectSpread({}, node.content), {}, {
          columns: cols
        })
      });
    }
    return node;
  });
  if (removed) return next;

  // Parent may be nested inside another columns/group block
  return mapNestedColumnLists(nodes, function (col) {
    return removeNodeAt(col, parentId, columnIndex, index);
  });
};
var insertNodeAt = function insertNodeAt(nodes, parentId, columnIndex, index, block) {
  if (parentId == null) {
    var _next2 = _toConsumableArray(nodes);
    _next2.splice(index, 0, block);
    return _next2;
  }
  var inserted = false;
  var next = nodes.map(function (node) {
    if (node.id === parentId) {
      inserted = true;
      var cols = _toConsumableArray(node.content.columns || []);
      var col = _toConsumableArray(cols[columnIndex] || []);
      col.splice(index, 0, block);
      cols[columnIndex] = col;
      return _objectSpread(_objectSpread({}, node), {}, {
        content: _objectSpread(_objectSpread({}, node.content), {}, {
          columns: cols
        })
      });
    }
    return node;
  });
  if (inserted) return next;

  // Parent may be nested inside another columns/group block
  return mapNestedColumnLists(nodes, function (col) {
    return insertNodeAt(col, parentId, columnIndex, index, block);
  });
};
export default function NewBuilderContainer(_ref) {
  var _activeNode$responsiv, _activeNode$elementSt, _activeNode$responsiv2;
  var initialTree = _ref.initialTree,
    _ref$initialBackgroun = _ref.initialBackgroundColor,
    initialBackgroundColor = _ref$initialBackgroun === void 0 ? "#FFFFFF" : _ref$initialBackgroun,
    _ref$initialBackgroun2 = _ref.initialBackgroundImage,
    initialBackgroundImage = _ref$initialBackgroun2 === void 0 ? "" : _ref$initialBackgroun2,
    _ref$initialDocumentP = _ref.initialDocumentPadding,
    initialDocumentPadding = _ref$initialDocumentP === void 0 ? 30 : _ref$initialDocumentP,
    _ref$initialDocumentP2 = _ref.initialDocumentPageSize,
    initialDocumentPageSize = _ref$initialDocumentP2 === void 0 ? "auto" : _ref$initialDocumentP2,
    onSave = _ref.onSave,
    _ref$height = _ref.height,
    height = _ref$height === void 0 ? "calc(100vh - 145px)" : _ref$height,
    _ref$standalone = _ref.standalone,
    standalone = _ref$standalone === void 0 ? false : _ref$standalone,
    _ref$headerActions = _ref.headerActions,
    headerActions = _ref$headerActions === void 0 ? null : _ref$headerActions,
    _ref$mentionConfig = _ref.mentionConfig,
    mentionConfig = _ref$mentionConfig === void 0 ? null : _ref$mentionConfig;
  var _useState = useState(function () {
      return getTreeFontFamily(initialTree || []);
    }),
    _useState2 = _slicedToArray(_useState, 2),
    globalFont = _useState2[0],
    setGlobalFont = _useState2[1];
  var _useState3 = useState(function () {
      return initialBackgroundColor || "#FFFFFF";
    }),
    _useState4 = _slicedToArray(_useState3, 2),
    globalBackgroundColor = _useState4[0],
    setGlobalBackgroundColor = _useState4[1];
  var _useState5 = useState(function () {
      return initialBackgroundImage || "";
    }),
    _useState6 = _slicedToArray(_useState5, 2),
    globalBackgroundImage = _useState6[0],
    setGlobalBackgroundImage = _useState6[1];
  var _useState7 = useState("#101828"),
    _useState8 = _slicedToArray(_useState7, 2),
    globalButtonBackgroundColor = _useState8[0],
    setGlobalButtonBackgroundColor = _useState8[1];
  var _useState9 = useState("#ffffff"),
    _useState10 = _slicedToArray(_useState9, 2),
    globalButtonTextColor = _useState10[0],
    setGlobalButtonTextColor = _useState10[1];
  var _useState11 = useState("#334155"),
    _useState12 = _slicedToArray(_useState11, 2),
    globalTextColor = _useState12[0],
    setGlobalTextColor = _useState12[1];
  var _useState13 = useState(function () {
      return initialDocumentPadding == null ? 30 : Number(initialDocumentPadding);
    }),
    _useState14 = _slicedToArray(_useState13, 2),
    documentPadding = _useState14[0],
    setDocumentPadding = _useState14[1];
  var _useState15 = useState(initialDocumentPageSize || "auto"),
    _useState16 = _slicedToArray(_useState15, 2),
    documentPageSize = _useState16[0],
    setDocumentPageSize = _useState16[1];
  var _useState17 = useState(false),
    _useState18 = _slicedToArray(_useState17, 2),
    showSafeArea = _useState18[0],
    setShowSafeArea = _useState18[1];
  var _useState19 = useState(false),
    _useState20 = _slicedToArray(_useState19, 2),
    showGrid = _useState20[0],
    setShowGrid = _useState20[1];
  var defaultTree = [{
    id: 1,
    type: "heading",
    content: {
      text: "Custom Builder"
    },
    style: {
      fontSize: "42px",
      textAlign: "center",
      color: "#1e293b",
      padding: "0",
      margin: "0",
      borderRadius: "0px",
      fontFamily: DEFAULT_FONT
    }
  }];
  var _useState21 = useState(function () {
      var sanitized = sanitizeBuilderTree(initialTree || []);
      return {
        tree: sanitized.length ? sanitized : defaultTree
      };
    }),
    _useState22 = _slicedToArray(_useState21, 2),
    page = _useState22[0],
    setPage = _useState22[1];
  var hasHydratedFromProps = useRef(false);
  useEffect(function () {
    var _firstButton$style, _firstButton$style2;
    if (hasHydratedFromProps.current || initialTree == null) {
      return;
    }
    var sanitized = sanitizeBuilderTree(initialTree);
    if (!sanitized.length) {
      return;
    }
    hasHydratedFromProps.current = true;
    setPage({
      tree: sanitized
    });
    setGlobalFont(getTreeFontFamily(sanitized));
    var walkForButton = function walkForButton(nodes) {
      if (!Array.isArray(nodes)) return null;
      var _iterator = _createForOfIteratorHelper(nodes),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var node = _step.value;
          if ((node === null || node === void 0 ? void 0 : node.type) === "button") return node;
          if (isNestedColumnContent(node === null || node === void 0 ? void 0 : node.content)) {
            var _iterator2 = _createForOfIteratorHelper(node.content.columns),
              _step2;
            try {
              for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                var col = _step2.value;
                var found = walkForButton(col);
                if (found) return found;
              }
            } catch (err) {
              _iterator2.e(err);
            } finally {
              _iterator2.f();
            }
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      return null;
    };
    var firstButton = walkForButton(sanitized);
    if (firstButton !== null && firstButton !== void 0 && (_firstButton$style = firstButton.style) !== null && _firstButton$style !== void 0 && _firstButton$style.background) {
      setGlobalButtonBackgroundColor(firstButton.style.background);
    }
    if (firstButton !== null && firstButton !== void 0 && (_firstButton$style2 = firstButton.style) !== null && _firstButton$style2 !== void 0 && _firstButton$style2.color) {
      setGlobalButtonTextColor(firstButton.style.color);
    }
    var walkForTextColor = function walkForTextColor(nodes) {
      if (!Array.isArray(nodes)) return null;
      var _iterator3 = _createForOfIteratorHelper(nodes),
        _step3;
      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var _node$style;
          var node = _step3.value;
          if (((node === null || node === void 0 ? void 0 : node.type) === "text" || (node === null || node === void 0 ? void 0 : node.type) === "heading") && (_node$style = node.style) !== null && _node$style !== void 0 && _node$style.color) {
            return node.style.color;
          }
          if (isNestedColumnContent(node === null || node === void 0 ? void 0 : node.content)) {
            var _iterator4 = _createForOfIteratorHelper(node.content.columns),
              _step4;
            try {
              for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
                var col = _step4.value;
                var found = walkForTextColor(col);
                if (found) return found;
              }
            } catch (err) {
              _iterator4.e(err);
            } finally {
              _iterator4.f();
            }
          }
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }
      return null;
    };
    var firstTextColor = walkForTextColor(sanitized);
    if (firstTextColor) {
      setGlobalTextColor(firstTextColor);
    }
  }, [initialTree]);
  useEffect(function () {
    if (initialBackgroundColor != null) {
      setGlobalBackgroundColor(initialBackgroundColor || "#FFFFFF");
    }
  }, [initialBackgroundColor]);
  useEffect(function () {
    if (initialBackgroundImage != null) {
      setGlobalBackgroundImage(initialBackgroundImage || "");
    }
  }, [initialBackgroundImage]);
  useEffect(function () {
    if (initialDocumentPadding != null) {
      setDocumentPadding(Number(initialDocumentPadding));
    }
  }, [initialDocumentPadding]);
  useEffect(function () {
    setDocumentPageSize(initialDocumentPageSize || "auto");
  }, [initialDocumentPageSize]);
  var _useState23 = useState(null),
    _useState24 = _slicedToArray(_useState23, 2),
    selected = _useState24[0],
    setSelected = _useState24[1];
  var _useState25 = useState(null),
    _useState26 = _slicedToArray(_useState25, 2),
    selectedElement = _useState26[0],
    setSelectedElement = _useState26[1];
  var _useState27 = useState([]),
    _useState28 = _slicedToArray(_useState27, 2),
    history = _useState28[0],
    setHistory = _useState28[1];
  var _useState29 = useState([]),
    _useState30 = _slicedToArray(_useState29, 2),
    future = _useState30[0],
    setFuture = _useState30[1];
  var _useState31 = useState(null),
    _useState32 = _slicedToArray(_useState31, 2),
    copyData = _useState32[0],
    setCopy = _useState32[1];

  // Drag and drop states
  var _useState33 = useState(EMPTY_DROP_POS),
    _useState34 = _slicedToArray(_useState33, 2),
    dragOverPos = _useState34[0],
    setDragOverPos = _useState34[1];
  var _useState35 = useState(false),
    _useState36 = _slicedToArray(_useState35, 2),
    isDragActive = _useState36[0],
    setIsDragActive = _useState36[1];

  // Left sidebar active tab state
  var _useState37 = useState("blocks"),
    _useState38 = _slicedToArray(_useState37, 2),
    activeLeftTab = _useState38[0],
    setActiveLeftTab = _useState38[1];
  var _useState39 = useState(readEmbeddedBuilderTemplates),
    _useState40 = _slicedToArray(_useState39, 2),
    savedTemplates = _useState40[0],
    setSavedTemplates = _useState40[1];
  var _useState41 = useState(false),
    _useState42 = _slicedToArray(_useState41, 2),
    savedTemplatesLoading = _useState42[0],
    setSavedTemplatesLoading = _useState42[1];

  // AI assistant states
  var _useState43 = useState(""),
    _useState44 = _slicedToArray(_useState43, 2),
    aiPrompt = _useState44[0],
    setAiPrompt = _useState44[1];
  var _useState45 = useState(false),
    _useState46 = _slicedToArray(_useState45, 2),
    aiLoading = _useState46[0],
    setAiLoading = _useState46[1];
  var _useState47 = useState(""),
    _useState48 = _slicedToArray(_useState47, 2),
    aiResult = _useState48[0],
    setAiResult = _useState48[1];
  var _useState49 = useState("openai"),
    _useState50 = _slicedToArray(_useState49, 2),
    aiProvider = _useState50[0],
    setAiProvider = _useState50[1];
  var _useState51 = useState({
      openai: "",
      gemini: "",
      claude: ""
    }),
    _useState52 = _slicedToArray(_useState51, 2),
    aiKeys = _useState52[0],
    setAiKeys = _useState52[1];
  var _useState53 = useState(false),
    _useState54 = _slicedToArray(_useState53, 2),
    aiKeysLoaded = _useState54[0],
    setAiKeysLoaded = _useState54[1];
  var aiKeysSaveTimerRef = useRef(null);

  // Toast notification state
  var _useState55 = useState({
      show: false,
      message: ""
    }),
    _useState56 = _slicedToArray(_useState55, 2),
    toast = _useState56[0],
    setToast = _useState56[1];

  // Custom confirmation dialog state
  var _useState57 = useState({
      isOpen: false,
      title: "Are you sure?",
      message: "",
      confirmLabel: "Yes",
      cancelLabel: "No",
      onConfirm: null,
      onCancel: null
    }),
    _useState58 = _slicedToArray(_useState57, 2),
    customConfirm = _useState58[0],
    setCustomConfirm = _useState58[1];

  // Viewport width state: 'desktop' | 'tablet' | 'mobile'
  var _useState59 = useState("desktop"),
    _useState60 = _slicedToArray(_useState59, 2),
    viewport = _useState60[0],
    setViewport = _useState60[1];

  // Image upload loading state: 'image-src' | 'background-image' | null
  var _useState61 = useState(null),
    _useState62 = _slicedToArray(_useState61, 2),
    imageUploading = _useState62[0],
    setImageUploading = _useState62[1];
  var _useState63 = useState(null),
    _useState64 = _slicedToArray(_useState63, 2),
    imageUploadError = _useState64[0],
    setImageUploadError = _useState64[1];

  // Right sidebar tab state: 'content' | 'style' | 'global'
  var _useState65 = useState("content"),
    _useState66 = _slicedToArray(_useState65, 2),
    activeRightTab = _useState66[0],
    setActiveRightTab = _useState66[1];

  // Compact layout: collapse sidebars to icon rails on smaller screens
  var COMPACT_BREAKPOINT = 1200;
  var _useState67 = useState(function () {
      return typeof window !== "undefined" && window.innerWidth < COMPACT_BREAKPOINT;
    }),
    _useState68 = _slicedToArray(_useState67, 2),
    isCompact = _useState68[0],
    setIsCompact = _useState68[1];
  var _useState69 = useState(function () {
      return typeof window === "undefined" ? SIDE_PANEL_MAX_WIDTH : resolveSidePanelWidth(window.innerWidth);
    }),
    _useState70 = _slicedToArray(_useState69, 2),
    sidePanelWidth = _useState70[0],
    setSidePanelWidth = _useState70[1];
  var _useState71 = useState(function () {
      return typeof window === "undefined" ? 288 : resolveLeftSidebarWidth(window.innerWidth);
    }),
    _useState72 = _slicedToArray(_useState71, 2),
    leftSidebarWidth = _useState72[0],
    setLeftSidebarWidth = _useState72[1];
  var _useState73 = useState(false),
    _useState74 = _slicedToArray(_useState73, 2),
    leftPanelExpanded = _useState74[0],
    setLeftPanelExpanded = _useState74[1];
  var _useState75 = useState(false),
    _useState76 = _slicedToArray(_useState75, 2),
    rightPanelExpanded = _useState76[0],
    setRightPanelExpanded = _useState76[1];
  useEffect(function () {
    var onResize = function onResize() {
      var compact = window.innerWidth < COMPACT_BREAKPOINT;
      setIsCompact(compact);
      setSidePanelWidth(resolveSidePanelWidth(window.innerWidth));
      setLeftSidebarWidth(resolveLeftSidebarWidth(window.innerWidth));
      if (!compact) {
        setLeftPanelExpanded(false);
        setRightPanelExpanded(false);
      }
    };
    window.addEventListener("resize", onResize);
    onResize();
    return function () {
      return window.removeEventListener("resize", onResize);
    };
  }, []);
  var selectBlock = function selectBlock(blockId) {
    setSelected(blockId);
    setSelectedElement(null);
    setImageUploadError(null);
    if (blockId) {
      setActiveRightTab("content");
      if (isCompact) {
        setRightPanelExpanded(true);
        setLeftPanelExpanded(false);
      }
      // Silently move any stale element padding/margin onto the block shell
      setPage(function (prev) {
        var node = findNodeRecursive(prev.tree, blockId);
        if (!node) return prev;
        var next = liftElementSpacingToBlock(node, "padding");
        next = liftElementSpacingToBlock(next, "margin");
        if (next === node) return prev;
        return _objectSpread(_objectSpread({}, prev), {}, {
          tree: updateNodeInTree(prev.tree, blockId, function () {
            return next;
          })
        });
      });
    }
  };
  var selectElement = function selectElement(blockId, elementKey) {
    setSelected(blockId);
    setSelectedElement(elementKey || null);
    setImageUploadError(null);
    if (blockId) {
      if (elementKey) {
        setActiveRightTab("style");
      }
      if (isCompact) {
        setRightPanelExpanded(true);
        setLeftPanelExpanded(false);
      }
    }
  };

  // Drag and drop refs to prevent React state resets on dragstart
  var dragSourceRef = useRef(null);
  var dragTypeRef = useRef(null);
  var dragSourceBlockIdRef = useRef(null);
  var dragOverPosRef = useRef(EMPTY_DROP_POS);
  useEffect(function () {
    dragOverPosRef.current = dragOverPos;
  }, [dragOverPos]);
  var setDropPosition = function setDropPosition(next) {
    dragOverPosRef.current = next;
    setDragOverPos(function (prev) {
      if (prev.parentId === next.parentId && prev.columnIndex === next.columnIndex && prev.index === next.index && prev.blockId === next.blockId) {
        return prev;
      }
      return next;
    });
  };
  var clearDragState = function clearDragState() {
    setIsDragActive(false);
    setDropPosition(EMPTY_DROP_POS);
    dragSourceRef.current = null;
    dragTypeRef.current = null;
    dragSourceBlockIdRef.current = null;
    if (typeof document !== "undefined") {
      document.querySelectorAll("[data-dragging]").forEach(function (el) {
        el.removeAttribute("data-dragging");
        el.style.opacity = "";
      });
    }
  };
  var showToast = function showToast(message) {
    setToast({
      show: true,
      message: message
    });
    setTimeout(function () {
      setToast({
        show: false,
        message: ""
      });
    }, 2500);
  };
  var showSavedTemplates = Boolean((headerActions === null || headerActions === void 0 ? void 0 : headerActions.templatesListUrl) && (headerActions === null || headerActions === void 0 ? void 0 : headerActions.templateDesignUrl) && (headerActions === null || headerActions === void 0 ? void 0 : headerActions.mode) !== "template");
  useEffect(function () {
    if (!showSavedTemplates) {
      return undefined;
    }
    var cancelled = false;
    setSavedTemplatesLoading(true);
    axios.get(headerActions.templatesListUrl, {
      headers: {
        Accept: "application/json",
        "X-Requested-With": "XMLHttpRequest"
      }
    }).then(function (response) {
      if (!cancelled) {
        var payload = response.data;
        var list = Array.isArray(payload === null || payload === void 0 ? void 0 : payload.templates) ? payload.templates : Array.isArray(payload) ? payload : [];
        if (list.length > 0) {
          setSavedTemplates(list);
        }
      }
    })["catch"](function () {})["finally"](function () {
      if (!cancelled) {
        setSavedTemplatesLoading(false);
      }
    });
    return function () {
      cancelled = true;
    };
  }, [showSavedTemplates, headerActions === null || headerActions === void 0 ? void 0 : headerActions.templatesListUrl]);
  var persistAiSettings = function persistAiSettings(nextKeys, nextProvider) {
    var _document$querySelect;
    var csrfToken = (_document$querySelect = document.querySelector('meta[name="csrf-token"]')) === null || _document$querySelect === void 0 ? void 0 : _document$querySelect.getAttribute("content");
    return axios.post("/builder/ai-keys", {
      keys: nextKeys,
      provider: nextProvider
    }, {
      headers: _objectSpread({}, csrfToken ? {
        "X-CSRF-TOKEN": csrfToken
      } : {})
    });
  };
  var scheduleAiSettingsSave = function scheduleAiSettingsSave(nextKeys, nextProvider) {
    if (aiKeysSaveTimerRef.current) {
      clearTimeout(aiKeysSaveTimerRef.current);
    }
    aiKeysSaveTimerRef.current = setTimeout(function () {
      persistAiSettings(nextKeys, nextProvider)["catch"](function () {
        showToast("Failed to save AI keys");
      });
    }, 500);
  };
  var handleAiProviderChange = function handleAiProviderChange(val) {
    setAiProvider(val);
    if (aiKeysLoaded) {
      scheduleAiSettingsSave(aiKeys, val);
    }
  };
  var handleAiKeyChange = function handleAiKeyChange(provider, val) {
    var updated = _objectSpread(_objectSpread({}, aiKeys), {}, _defineProperty({}, provider, val));
    setAiKeys(updated);
    if (aiKeysLoaded) {
      scheduleAiSettingsSave(updated, aiProvider);
    }
  };
  useEffect(function () {
    var _document$querySelect2;
    var cancelled = false;
    var csrfToken = (_document$querySelect2 = document.querySelector('meta[name="csrf-token"]')) === null || _document$querySelect2 === void 0 ? void 0 : _document$querySelect2.getAttribute("content");
    axios.get("/builder/ai-keys", {
      headers: _objectSpread({}, csrfToken ? {
        "X-CSRF-TOKEN": csrfToken
      } : {})
    }).then(function (res) {
      var _res$data, _res$data2;
      if (cancelled) return;
      var dbKeys = ((_res$data = res.data) === null || _res$data === void 0 ? void 0 : _res$data.keys) || {};
      var dbProvider = ((_res$data2 = res.data) === null || _res$data2 === void 0 ? void 0 : _res$data2.provider) || "openai";
      var hasDbKeys = Boolean(dbKeys.openai || dbKeys.gemini || dbKeys.claude);
      var localKeys = {
        openai: safeStorageGet("builder_key_openai"),
        gemini: safeStorageGet("builder_key_gemini"),
        claude: safeStorageGet("builder_key_claude")
      };
      var hasLocalKeys = Boolean(localKeys.openai || localKeys.gemini || localKeys.claude);
      var localProvider = safeStorageGet("builder_ai_provider", "openai");
      if (!hasDbKeys && hasLocalKeys) {
        setAiKeys(localKeys);
        setAiProvider(localProvider);
        setAiKeysLoaded(true);
        persistAiSettings(localKeys, localProvider).then(function () {
          try {
            localStorage.removeItem("builder_key_openai");
            localStorage.removeItem("builder_key_gemini");
            localStorage.removeItem("builder_key_claude");
            localStorage.removeItem("builder_ai_provider");
          } catch (_) {
            /* ignore */
          }
        })["catch"](function () {
          showToast("Failed to migrate AI keys");
        });
        return;
      }
      setAiKeys({
        openai: dbKeys.openai || "",
        gemini: dbKeys.gemini || "",
        claude: dbKeys.claude || ""
      });
      setAiProvider(dbProvider);
      setAiKeysLoaded(true);
    })["catch"](function () {
      if (cancelled) return;
      setAiKeys({
        openai: safeStorageGet("builder_key_openai"),
        gemini: safeStorageGet("builder_key_gemini"),
        claude: safeStorageGet("builder_key_claude")
      });
      setAiProvider(safeStorageGet("builder_ai_provider", "openai"));
      setAiKeysLoaded(true);
    });
    return function () {
      cancelled = true;
      if (aiKeysSaveTimerRef.current) {
        clearTimeout(aiKeysSaveTimerRef.current);
      }
    };
  }, []);
  var triggerConfirm = function triggerConfirm(message, _onConfirm) {
    var _onCancel = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
    var title = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : "Are you sure?";
    setCustomConfirm({
      isOpen: true,
      title: title,
      message: message,
      confirmLabel: "Yes",
      cancelLabel: "No",
      onConfirm: function onConfirm() {
        setCustomConfirm(function (prev) {
          return _objectSpread(_objectSpread({}, prev), {}, {
            isOpen: false
          });
        });
        if (_onConfirm) _onConfirm();
      },
      onCancel: function onCancel() {
        setCustomConfirm(function (prev) {
          return _objectSpread(_objectSpread({}, prev), {}, {
            isOpen: false
          });
        });
        if (_onCancel) _onCancel();
      }
    });
  };
  var generateLocalFallback = function generateLocalFallback(prompt) {
    setAiLoading(false);
    var p = prompt.toLowerCase();
    if (p.includes("proposal") || p.includes("intro") || p.includes("welcome")) {
      setAiResult("\u2728 Premium Project Proposal Intro:\n\nWe are thrilled to submit this proposal for your digital transformation. WillowSpace partner agencies deliver custom web applications, responsive designs, and fully-managed integrations built to scale operations. Our goal is to streamline your workflows, increase conversion rates by 25%, and automate manual data processes.");
    } else if (p.includes("pricing") || p.includes("cost") || p.includes("plan")) {
      setAiResult("\u2B50 Modern Project Pricing Plan:\n\nOur custom-tailored package includes:\n- Full-stack UI Design & React Engineering\n- Custom CMS Integration & Database Setup\n- Automated 3rd Party APIs & Stripe Checkout\n- Total Cost: $4,500 USD (Net 30)");
    } else if (p.includes("testimonial") || p.includes("review") || p.includes("client")) {
      setAiResult("\uD83D\uDDE3\uFE0F Client Testimonial:\n\n\"WillowSpace has transformed the way we collaborate with clients. The custom portal and interactive document systems are absolute game-changers.\"\n\n\u2014 John Doe, Creative Director at Nexus Design");
    } else if (p.includes("feature") || p.includes("service") || p.includes("what we do")) {
      setAiResult("\u26A1 Key Services & Core Offerings:\n\n1. High-Fidelity UI/UX Prototyping\n2. Responsive Web & App Development\n3. Dedicated Client Communication Portals\n4. Post-Launch SLA Support & Maintenance");
    } else {
      setAiResult("\uD83D\uDCA1 Generated Copy suggestion:\n\nOptimized Client Experience: Streamline project requirements, automate contract sign-offs, and track proposal milestones seamlessly in real time.");
    }
    showToast("Loaded Local AI Fallback Copy");
  };
  var handleDemoGenerate = function handleDemoGenerate() {
    if (!aiPrompt.trim()) return;
    generateLocalFallback(aiPrompt);
  };
  var handleAiGenerate = function handleAiGenerate() {
    if (!aiPrompt.trim()) return;
    if (aiProvider === "demo") {
      handleDemoGenerate();
      return;
    }
    setAiLoading(true);
    setAiResult("");
    var activeKey = aiKeys[aiProvider] || "";
    axios.post('/builder/ai-chat', {
      prompt: aiPrompt,
      provider: aiProvider,
      apiKey: activeKey
    }).then(function (res) {
      setAiLoading(false);
      if (res.data && res.data.response) {
        setAiResult(res.data.response);
        showToast("".concat(aiProvider.toUpperCase(), " response loaded!"));
      } else {
        generateLocalFallback(aiPrompt);
      }
    })["catch"](function (err) {
      setAiLoading(false);
      var errMsg = err.response && err.response.data && err.response.data.error ? err.response.data.error : "";
      if (errMsg) {
        setAiResult("\u274C ".concat(aiProvider.toUpperCase(), " Request Failed:\n\n").concat(errMsg, "\n\n\uD83D\uDC49 Make sure the API Key you entered above is valid and active."));
        showToast("AI Request Failed");
      } else {
        generateLocalFallback(aiPrompt);
      }
    });
  };
  var buildBlocksFromTemplate = function buildBlocksFromTemplate(templateBlocks) {
    return templateBlocks.filter(Boolean).map(function (b) {
      var _b$style, _b$style2, _b$style3;
      var node = _objectSpread(_objectSpread({}, b), {}, {
        id: createUniqueBlockId(),
        content: cloneBlockContent(b.content),
        style: _objectSpread(_objectSpread(_objectSpread({}, defaultBlockStyle(b)), {}, {
          fontFamily: getActiveFontFamily()
        }, b.type === "button" ? {
          color: ((_b$style = b.style) === null || _b$style === void 0 ? void 0 : _b$style.color) || getActiveButtonTextColor(),
          background: ((_b$style2 = b.style) === null || _b$style2 === void 0 ? void 0 : _b$style2.background) || getActiveButtonBackgroundColor()
        } : {
          color: ((_b$style3 = b.style) === null || _b$style3 === void 0 ? void 0 : _b$style3.color) || getActiveTextColor()
        }), b.style || {})
      });
      // Nested column/group children also need unique ids when present.
      if (isNestedColumnContent(node.content)) {
        node.content.columns = node.content.columns.map(function (col) {
          return Array.isArray(col) ? col.map(function (child) {
            return cloneBlockNode(child);
          }) : col;
        });
      }
      return node;
    });
  };
  var addSection = function addSection(templateName) {
    var _inserted;
    var tmpl = sectionTemplates[templateName];
    if (!tmpl) return;
    var newBlocks = buildBlocksFromTemplate(tmpl.blocks);
    var inserted;

    // Multi-block sections wrap in a group so the whole section can be selected/moved/deleted.
    if (newBlocks.length > 1) {
      var groupId = createUniqueBlockId();
      inserted = {
        id: groupId,
        type: "group",
        content: {
          columns: [newBlocks],
          sectionLabel: tmpl.label || "Section"
        },
        style: withDefaultNewBlockMargin({
          padding: "16px",
          borderRadius: "8px",
          borderStyle: "none",
          borderWidth: "0px"
        })
      };
      change({
        tree: [].concat(_toConsumableArray(page.tree), [inserted])
      });
    } else {
      inserted = newBlocks[0];
      change({
        tree: [].concat(_toConsumableArray(page.tree), _toConsumableArray(newBlocks))
      });
    }
    if ((_inserted = inserted) !== null && _inserted !== void 0 && _inserted.id) {
      setSelected(inserted.id);
      setSelectedElement(null);
      setActiveRightTab("style");
    }
    showToast("Inserted ".concat(tmpl.label));
  };
  var applySavedDocumentTemplate = function applySavedDocumentTemplate(template) {
    if (!(template !== null && template !== void 0 && template.id) || !(headerActions !== null && headerActions !== void 0 && headerActions.templateDesignUrl)) {
      return;
    }
    var apply = function apply() {
      var documentId = (mentionConfig === null || mentionConfig === void 0 ? void 0 : mentionConfig.mode) !== "template" ? mentionConfig === null || mentionConfig === void 0 ? void 0 : mentionConfig.documentId : null;
      var url = "".concat(headerActions.templateDesignUrl).concat(template.id).concat(documentId ? "?document_id=".concat(encodeURIComponent(documentId)) : "");
      axios.get(url).then( /*#__PURE__*/function () {
        var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(response) {
          var _response$data, _response$data$docume;
          var tree;
          return _regeneratorRuntime().wrap(function _callee$(_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                if ((_response$data = response.data) !== null && _response$data !== void 0 && _response$data.isNewBuilder) {
                  _context.next = 3;
                  break;
                }
                showToast("This template cannot be used here");
                return _context.abrupt("return");
              case 3:
                tree = sanitizeBuilderTree((response.data.tree || []).map(function (node) {
                  return cloneBlockNode(node);
                }).filter(Boolean));
                if (!(typeof (mentionConfig === null || mentionConfig === void 0 ? void 0 : mentionConfig.resolveTreeIdentifiers) === "function")) {
                  _context.next = 8;
                  break;
                }
                _context.next = 7;
                return mentionConfig.resolveTreeIdentifiers(tree);
              case 7:
                tree = _context.sent;
              case 8:
                change({
                  tree: tree
                });
                setGlobalBackgroundColor(response.data.background_color || "#FFFFFF");
                setGlobalBackgroundImage(response.data.background_image || "");
                setDocumentPadding((_response$data$docume = response.data.document_padding) !== null && _response$data$docume !== void 0 ? _response$data$docume : 30);
                setDocumentPageSize(response.data.document_page_size || "auto");
                setSelected(null);
                setSelectedElement(null);
                if (typeof (headerActions === null || headerActions === void 0 ? void 0 : headerActions.onApplyDocumentTemplate) === "function") {
                  headerActions.onApplyDocumentTemplate(template);
                }
                showToast("Applied ".concat(template.name));
              case 17:
              case "end":
                return _context.stop();
            }
          }, _callee);
        }));
        return function (_x2) {
          return _ref2.apply(this, arguments);
        };
      }())["catch"](function () {
        return showToast("Could not load template");
      });
    };
    triggerConfirm("Selecting \"".concat(template.name, "\" will delete the current design. This cannot be undone."), apply, null, "Delete current design?");
  };
  var applyPageTemplate = function applyPageTemplate(templateKey) {
    var tmpl = pageTemplates[templateKey];
    if (!tmpl) return;
    var apply = function apply() {
      var newBlocks = buildBlocksFromTemplate(tmpl.blocks);
      change({
        tree: newBlocks
      });
      setSelected(null);
      showToast("Applied ".concat(tmpl.label));
    };
    if (page.tree.length > 0) {
      triggerConfirm("Replace current page content with \"".concat(tmpl.label, "\"? This cannot be undone."), apply);
    } else {
      apply();
    }
  };
  var applyGlobalFont = function applyGlobalFont(font) {
    setGlobalFont(font);
    change({
      tree: mapTreeNodes(function (node) {
        return _objectSpread(_objectSpread({}, node), {}, {
          style: _objectSpread(_objectSpread({}, node.style), {}, {
            fontFamily: font
          }, isSingleWeightFont(font) ? {
            fontWeight: "normal"
          } : {})
        });
      })
    });
    showToast("Applied Global Font");
  };
  var getActiveFontFamily = function getActiveFontFamily() {
    return globalFont;
  };
  var applyGlobalTextColor = function applyGlobalTextColor(color) {
    var nextColor = color || "#334155";
    if (nextColor === globalTextColor) {
      return;
    }
    setGlobalTextColor(nextColor);
    // Non-text / non-button blocks — buttons have their own global color controls
    var excludeTypes = ["divider", "spacer", "image", "page-break", "gallery", "html", "button"];
    change({
      tree: mapTreeNodes(function (node) {
        if (excludeTypes.includes(node.type)) {
          return node;
        }
        var nextStyle = _objectSpread(_objectSpread({}, node.style), {}, {
          color: nextColor
        });
        if (node.type === "list") {
          nextStyle.markerColor = nextColor;
        }
        var nextElementStyles = node.elementStyles;
        if (node.elementStyles && _typeof(node.elementStyles) === "object") {
          nextElementStyles = {};
          Object.entries(node.elementStyles).forEach(function (_ref3) {
            var _ref4 = _slicedToArray(_ref3, 2),
              key = _ref4[0],
              elStyle = _ref4[1];
            // Skip CTA / pricing button text parts — controlled by global button colors
            if (key === "buttonText" || String(key).endsWith("_buttonText")) {
              nextElementStyles[key] = elStyle;
              return;
            }
            if (elStyle && _typeof(elStyle) === "object" && elStyle.color !== undefined) {
              nextElementStyles[key] = _objectSpread(_objectSpread({}, elStyle), {}, {
                color: nextColor
              });
            } else {
              nextElementStyles[key] = elStyle;
            }
          });
        }
        return _objectSpread(_objectSpread({}, node), {}, {
          style: nextStyle
        }, nextElementStyles ? {
          elementStyles: nextElementStyles
        } : {});
      })
    });
    showToast("Applied Global Text Color");
  };
  var getActiveTextColor = function getActiveTextColor() {
    return globalTextColor || "#334155";
  };
  var getActiveButtonBackgroundColor = function getActiveButtonBackgroundColor() {
    return globalButtonBackgroundColor || "#101828";
  };
  var getActiveButtonTextColor = function getActiveButtonTextColor() {
    return globalButtonTextColor || "#ffffff";
  };
  var applyGlobalButtonBackgroundColor = function applyGlobalButtonBackgroundColor(color) {
    var nextColor = !color || color === "transparent" ? "#101828" : color;
    setGlobalButtonBackgroundColor(nextColor);
    change({
      tree: mapTreeNodes(function (node) {
        var _node$content2;
        if (node.type === "button") {
          return _objectSpread(_objectSpread({}, node), {}, {
            style: _objectSpread(_objectSpread({}, node.style), {}, {
              background: nextColor
            })
          });
        }
        var nextElementStyles = _objectSpread({}, node.elementStyles || {});
        var changed = false;
        if (node.type === "cta") {
          nextElementStyles.buttonText = _objectSpread(_objectSpread({}, nextElementStyles.buttonText || {}), {}, {
            background: nextColor
          });
          changed = true;
        }
        if (node.type === "pricing" && Array.isArray((_node$content2 = node.content) === null || _node$content2 === void 0 ? void 0 : _node$content2.plans)) {
          node.content.plans.forEach(function (_, i) {
            var key = "plan_".concat(i, "_buttonText");
            nextElementStyles[key] = _objectSpread(_objectSpread({}, nextElementStyles[key] || {}), {}, {
              background: nextColor
            });
          });
          changed = true;
        }
        Object.entries(nextElementStyles).forEach(function (_ref5) {
          var _ref6 = _slicedToArray(_ref5, 2),
            key = _ref6[0],
            elStyle = _ref6[1];
          if ((key === "buttonText" || String(key).endsWith("_buttonText")) && elStyle && _typeof(elStyle) === "object" && elStyle.background !== nextColor) {
            nextElementStyles[key] = _objectSpread(_objectSpread({}, elStyle), {}, {
              background: nextColor
            });
            changed = true;
          }
        });
        if (changed) {
          return _objectSpread(_objectSpread({}, node), {}, {
            elementStyles: nextElementStyles
          });
        }
        return node;
      })
    });
    showToast("Applied Global Button Background");
  };
  var applyGlobalButtonTextColor = function applyGlobalButtonTextColor(color) {
    var nextColor = !color || color === "transparent" ? "#ffffff" : color;
    setGlobalButtonTextColor(nextColor);
    change({
      tree: mapTreeNodes(function (node) {
        var _node$content3;
        if (node.type === "button") {
          return _objectSpread(_objectSpread({}, node), {}, {
            style: _objectSpread(_objectSpread({}, node.style), {}, {
              color: nextColor
            })
          });
        }
        var nextElementStyles = _objectSpread({}, node.elementStyles || {});
        var changed = false;
        if (node.type === "cta") {
          nextElementStyles.buttonText = _objectSpread(_objectSpread({}, nextElementStyles.buttonText || {}), {}, {
            color: nextColor
          });
          changed = true;
        }
        if (node.type === "pricing" && Array.isArray((_node$content3 = node.content) === null || _node$content3 === void 0 ? void 0 : _node$content3.plans)) {
          node.content.plans.forEach(function (_, i) {
            var key = "plan_".concat(i, "_buttonText");
            nextElementStyles[key] = _objectSpread(_objectSpread({}, nextElementStyles[key] || {}), {}, {
              color: nextColor
            });
          });
          changed = true;
        }
        Object.entries(nextElementStyles).forEach(function (_ref7) {
          var _ref8 = _slicedToArray(_ref7, 2),
            key = _ref8[0],
            elStyle = _ref8[1];
          if ((key === "buttonText" || String(key).endsWith("_buttonText")) && elStyle && _typeof(elStyle) === "object" && elStyle.color !== nextColor) {
            nextElementStyles[key] = _objectSpread(_objectSpread({}, elStyle), {}, {
              color: nextColor
            });
            changed = true;
          }
        });
        if (changed) {
          return _objectSpread(_objectSpread({}, node), {}, {
            elementStyles: nextElementStyles
          });
        }
        return node;
      })
    });
    showToast("Applied Global Button Text Color");
  };
  var applyGlobalBackgroundColor = function applyGlobalBackgroundColor(color) {
    var nextColor = !color || color === "transparent" ? "#FFFFFF" : color;
    setGlobalBackgroundColor(nextColor);
    showToast("Applied Document Background");
  };
  var getActiveBackgroundColor = function getActiveBackgroundColor() {
    return globalBackgroundColor || "#FFFFFF";
  };
  var getActiveBackgroundImage = function getActiveBackgroundImage() {
    return globalBackgroundImage || "";
  };
  var setGlobalBackgroundImageUrl = function setGlobalBackgroundImageUrl(url) {
    setGlobalBackgroundImage(url || "");
    showToast(url ? "Applied Document Background Image" : "Removed Document Background Image");
  };
  function handleGlobalBackgroundImageUpload(_x3) {
    return _handleGlobalBackgroundImageUpload.apply(this, arguments);
  }
  function _handleGlobalBackgroundImageUpload() {
    _handleGlobalBackgroundImageUpload = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(e) {
      var _e$target$files;
      var file, uploadKey, result;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            file = (_e$target$files = e.target.files) === null || _e$target$files === void 0 ? void 0 : _e$target$files[0];
            e.target.value = "";
            if (file) {
              _context2.next = 4;
              break;
            }
            return _context2.abrupt("return");
          case 4:
            uploadKey = "global-background-image";
            setImageUploadError(null);
            setImageUploading(uploadKey);
            _context2.next = 9;
            return uploadBuilderImage(file);
          case 9:
            result = _context2.sent;
            setImageUploading(null);
            if (!result.error) {
              _context2.next = 14;
              break;
            }
            setImageUploadError({
              key: uploadKey,
              message: result.error
            });
            return _context2.abrupt("return");
          case 14:
            setGlobalBackgroundImageUrl(result.url);
          case 15:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return _handleGlobalBackgroundImageUpload.apply(this, arguments);
  }
  var handleFontChange = function handleFontChange(fontValue) {
    var fontObj = GOOGLE_FONTS.find(function (f) {
      return f.value === fontValue;
    });
    if (fontObj) {
      ensureGoogleFontLoaded(fontValue);
      applyGlobalFont(fontValue);
    }
  };
  var handleDragStartSidebar = function handleDragStartSidebar(e, type) {
    dragSourceRef.current = "sidebar";
    dragTypeRef.current = type;
    dragSourceBlockIdRef.current = null;
    e.dataTransfer.effectAllowed = "copy";
    e.dataTransfer.setData("text/plain", type);
    window.setTimeout(function () {
      return setIsDragActive(true);
    }, 0);
  };
  var handleDragStartCanvas = function handleDragStartCanvas(e, blockId) {
    dragSourceRef.current = "canvas";
    dragSourceBlockIdRef.current = blockId;
    e.dataTransfer.effectAllowed = "move";
    e.dataTransfer.setData("text/plain", String(blockId));
    var blockEl = typeof document !== "undefined" ? document.querySelector("[data-builder-block][data-block-id=\"".concat(blockId, "\"]")) : null;
    if (blockEl) {
      blockEl.setAttribute("data-dragging", "true");
      blockEl.style.opacity = "0.45";
      try {
        e.dataTransfer.setDragImage(blockEl, 24, 16);
      } catch (_) {
        // Some browsers reject setDragImage — native ghost is fine
      }
    }
    window.setTimeout(function () {
      return setIsDragActive(true);
    }, 0);
  };
  var handleDragOverCanvas = function handleDragOverCanvas(e, parentId, columnIndex, insertIndex) {
    e.preventDefault();
    e.stopPropagation();
    if (dragSourceRef.current === "sidebar") {
      e.dataTransfer.dropEffect = "copy";
    } else {
      e.dataTransfer.dropEffect = "move";
    }
    setDropPosition({
      parentId: parentId !== null && parentId !== void 0 ? parentId : null,
      columnIndex: columnIndex !== null && columnIndex !== void 0 ? columnIndex : null,
      index: insertIndex,
      blockId: null
    });
  };
  var createSidebarBlock = function createSidebarBlock(blockType) {
    var _block$style, _block$style2, _block$style3;
    var block = blocks.find(function (b) {
      return b.type === blockType;
    });
    if (!block) return null;
    return {
      id: createUniqueBlockId(),
      type: block.type,
      content: cloneBlockContent(block.content),
      style: _objectSpread(_objectSpread(_objectSpread({}, defaultBlockStyle(block)), {}, {
        fontFamily: getActiveFontFamily()
      }, block.type === "button" ? {
        color: ((_block$style = block.style) === null || _block$style === void 0 ? void 0 : _block$style.color) || getActiveButtonTextColor(),
        background: ((_block$style2 = block.style) === null || _block$style2 === void 0 ? void 0 : _block$style2.background) || getActiveButtonBackgroundColor()
      } : {
        color: ((_block$style3 = block.style) === null || _block$style3 === void 0 ? void 0 : _block$style3.color) || getActiveTextColor()
      }), block.style || {})
    };
  };
  var performDropAt = function performDropAt(parentId, columnIndex, insertIndex) {
    var source = dragSourceRef.current;
    if (!source || insertIndex == null) return false;
    if (source === "sidebar") {
      var newBlock = createSidebarBlock(dragTypeRef.current);
      if (!newBlock) return false;
      change({
        tree: insertNodeAt(page.tree, parentId, columnIndex, insertIndex, newBlock)
      });
      var block = blocks.find(function (b) {
        return b.type === dragTypeRef.current;
      });
      showToast("Added ".concat((block === null || block === void 0 ? void 0 : block.label) || "block", " block"));
      return true;
    }
    if (source === "canvas") {
      var blockId = dragSourceBlockIdRef.current;
      if (!blockId) return false;
      var loc = findNodeLocation(page.tree, blockId);
      if (!loc) return false;
      var movedBlock = getNodeAt(page.tree, loc.parentId, loc.columnIndex, loc.index);
      if (!movedBlock) return false;
      var insertIdx = insertIndex;
      if (isSameListTarget(parentId, columnIndex, loc) && loc.index < insertIdx) {
        insertIdx -= 1;
      }

      // Same slot — nothing to do
      if (isSameListTarget(parentId, columnIndex, loc) && insertIdx === loc.index) {
        return false;
      }

      // Dropping a group/column into its own child would orphan the tree
      if (parentId != null && isNodeInsideBlock(movedBlock, parentId)) {
        showToast("Can't drop a block inside itself");
        return false;
      }
      var tree = removeNodeAt(page.tree, loc.parentId, loc.columnIndex, loc.index);
      tree = insertNodeAt(tree, parentId, columnIndex, insertIdx, movedBlock);
      change({
        tree: tree
      });
      showToast("Reordered block");
      return true;
    }
    return false;
  };
  var handleDropCanvas = function handleDropCanvas(e, parentId, columnIndex, insertIndex) {
    var _pos$parentId, _pos$columnIndex;
    e.preventDefault();
    e.stopPropagation();
    var pos = dragOverPosRef.current;
    var hasExplicitIndex = insertIndex != null;
    performDropAt(hasExplicitIndex ? parentId : (_pos$parentId = pos.parentId) !== null && _pos$parentId !== void 0 ? _pos$parentId : null, hasExplicitIndex ? columnIndex : (_pos$columnIndex = pos.columnIndex) !== null && _pos$columnIndex !== void 0 ? _pos$columnIndex : null, hasExplicitIndex ? insertIndex : pos.index);
    clearDragState();
  };
  var handleDropCanvasBg = function handleDropCanvasBg(e) {
    e.preventDefault();
    var pos = dragOverPosRef.current;
    if (pos.index != null) {
      performDropAt(pos.parentId, pos.columnIndex, pos.index);
    } else if (dragSourceRef.current === "sidebar") {
      var block = blocks.find(function (b) {
        return b.type === dragTypeRef.current;
      });
      if (block) {
        add(block);
      }
    }
    clearDragState();
  };

  // Sync state upward when page tree changes
  useEffect(function () {
    if (onSave) {
      var activeBackgroundColor = globalBackgroundColor || "#FFFFFF";
      var activeBackgroundImage = globalBackgroundImage || "";
      var htmlContent = generateHtml(page.tree, globalFont || getTreeFontFamily(page.tree), activeBackgroundColor, documentPadding, documentPageSize, activeBackgroundImage);
      var designContent = {
        tree: page.tree,
        isNewBuilder: true,
        background_color: activeBackgroundColor,
        background_image: activeBackgroundImage,
        document_padding: documentPadding,
        document_page_size: documentPageSize
      };
      onSave(designContent, htmlContent);
    }
  }, [page, globalBackgroundColor, globalBackgroundImage, globalFont, documentPadding, documentPageSize]);

  // Load only fonts used on the canvas (not the full Google catalog)
  useEffect(function () {
    ensureGoogleFontLoaded(globalFont || DEFAULT_FONT);
    collectTreeFontFamilies(page === null || page === void 0 ? void 0 : page.tree).forEach(function (fontVal) {
      return ensureGoogleFontLoaded(fontVal);
    });
  }, [page === null || page === void 0 ? void 0 : page.tree, globalFont]);
  useEffect(function () {
    var onDragEnd = function onDragEnd() {
      return clearDragState();
    };
    document.addEventListener("dragend", onDragEnd);
    return function () {
      return document.removeEventListener("dragend", onDragEnd);
    };
  }, []);
  function change(data) {
    setHistory([].concat(_toConsumableArray(history), [page]));
    setPage(data);
    setFuture([]);
  }

  // Recursive tree map so edits also reach blocks nested inside column layouts.
  var mapTreeNodes = function mapTreeNodes(mapper) {
    return mapNodesRecursive(page.tree, mapper);
  };
  function patchSelected(updater) {
    if (!selected) return;
    var target = findNodeRecursive(page.tree, selected);
    if (target !== null && target !== void 0 && target.locked) return;
    change({
      tree: updateNodeInTree(page.tree, selected, updater)
    });
  }
  function applyStylePatch(styleUpdater) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    if (!selected) return;
    var blockOnly = options.blockOnly === true;
    patchSelected(function (node) {
      var _node$responsiveStyle;
      if (selectedElement && !blockOnly) {
        var _node$elementStyles, _node$responsiveEleme;
        var baseElementStyle = ((_node$elementStyles = node.elementStyles) === null || _node$elementStyles === void 0 ? void 0 : _node$elementStyles[selectedElement]) || {};
        var responsiveElementStyle = viewport === "desktop" ? {} : ((_node$responsiveEleme = node.responsiveElementStyles) === null || _node$responsiveEleme === void 0 || (_node$responsiveEleme = _node$responsiveEleme[viewport]) === null || _node$responsiveEleme === void 0 ? void 0 : _node$responsiveEleme[selectedElement]) || {};
        var _current = _objectSpread(_objectSpread({}, baseElementStyle), responsiveElementStyle);
        var _next3 = styleUpdater(_current, node);
        if (viewport !== "desktop") {
          var _node$responsiveEleme2;
          return _objectSpread(_objectSpread({}, node), {}, {
            responsiveElementStyles: _objectSpread(_objectSpread({}, node.responsiveElementStyles || {}), {}, _defineProperty({}, viewport, _objectSpread(_objectSpread({}, ((_node$responsiveEleme2 = node.responsiveElementStyles) === null || _node$responsiveEleme2 === void 0 ? void 0 : _node$responsiveEleme2[viewport]) || {}), {}, _defineProperty({}, selectedElement, _next3))))
          });
        }
        return _objectSpread(_objectSpread({}, node), {}, {
          elementStyles: _objectSpread(_objectSpread({}, node.elementStyles || {}), {}, _defineProperty({}, selectedElement, _next3))
        });
      }
      var current = _objectSpread(_objectSpread({}, node.style || {}), viewport === "desktop" ? {} : ((_node$responsiveStyle = node.responsiveStyles) === null || _node$responsiveStyle === void 0 ? void 0 : _node$responsiveStyle[viewport]) || {});
      var next = styleUpdater(current, node);
      if (viewport !== "desktop") {
        return _objectSpread(_objectSpread({}, node), {}, {
          responsiveStyles: _objectSpread(_objectSpread({}, node.responsiveStyles || {}), {}, _defineProperty({}, viewport, next))
        });
      }
      return _objectSpread(_objectSpread({}, node), {}, {
        style: next
      });
    });
  }
  function resetResponsiveStyles() {
    if (!selected || viewport === "desktop") return;
    patchSelected(function (node) {
      var responsiveStyles = _objectSpread({}, node.responsiveStyles || {});
      var responsiveElementStyles = _objectSpread({}, node.responsiveElementStyles || {});
      if (selectedElement) {
        var viewportElements = _objectSpread({}, responsiveElementStyles[viewport] || {});
        delete viewportElements[selectedElement];
        responsiveElementStyles[viewport] = viewportElements;
      } else {
        delete responsiveStyles[viewport];
      }
      return _objectSpread(_objectSpread({}, node), {}, {
        responsiveStyles: responsiveStyles,
        responsiveElementStyles: responsiveElementStyles
      });
    });
    showToast("Reset ".concat(viewport, " styles"));
  }
  function add(b) {
    var _b$style4, _b$style5, _b$style6;
    var newId = createUniqueBlockId();
    change({
      tree: [].concat(_toConsumableArray(page.tree), [{
        id: newId,
        type: b.type,
        content: cloneBlockContent(b.content),
        style: _objectSpread(_objectSpread(_objectSpread({}, defaultBlockStyle(b)), {}, {
          fontFamily: getActiveFontFamily()
        }, b.type === "button" ? {
          color: ((_b$style4 = b.style) === null || _b$style4 === void 0 ? void 0 : _b$style4.color) || getActiveButtonTextColor(),
          background: ((_b$style5 = b.style) === null || _b$style5 === void 0 ? void 0 : _b$style5.background) || getActiveButtonBackgroundColor()
        } : {
          color: ((_b$style6 = b.style) === null || _b$style6 === void 0 ? void 0 : _b$style6.color) || getActiveTextColor()
        }), b.style || {})
      }])
    });
    setSelected(newId);
    setSelectedElement(null);
    setActiveRightTab("content");
    showToast("Added ".concat(b.label, " block"));
  }
  function toggleBlockLock(blockId) {
    var target = findNodeRecursive(page.tree, blockId);
    if (!target) return;
    var nextLocked = !target.locked;
    change({
      tree: updateNodeInTree(page.tree, blockId, function (node) {
        return _objectSpread(_objectSpread({}, node), {}, {
          locked: nextLocked
        });
      })
    });
    setSelected(blockId);
    setSelectedElement(null);
    showToast(nextLocked ? "Layer locked" : "Layer unlocked");
  }
  function moveBlockTo(blockId, left, top) {
    var target = findNodeRecursive(page.tree, blockId);
    if (!target || target.locked) return;
    change({
      tree: updateNodeInTree(page.tree, blockId, function (node) {
        var _node$responsiveStyle2, _current$zIndex;
        var current = _objectSpread(_objectSpread({}, node.style || {}), viewport === "desktop" ? {} : ((_node$responsiveStyle2 = node.responsiveStyles) === null || _node$responsiveStyle2 === void 0 ? void 0 : _node$responsiveStyle2[viewport]) || {});
        var movedStyle = _objectSpread(_objectSpread({}, current), {}, {
          position: "absolute",
          left: "".concat(Math.round(left / 5) * 5, "px"),
          top: "".concat(Math.round(top / 5) * 5, "px"),
          right: undefined,
          bottom: undefined,
          zIndex: (_current$zIndex = current.zIndex) !== null && _current$zIndex !== void 0 ? _current$zIndex : 2
        });
        if (viewport === "desktop") {
          return _objectSpread(_objectSpread({}, node), {}, {
            style: movedStyle
          });
        }
        return _objectSpread(_objectSpread({}, node), {}, {
          responsiveStyles: _objectSpread(_objectSpread({}, node.responsiveStyles || {}), {}, _defineProperty({}, viewport, movedStyle))
        });
      })
    });
  }
  function remove() {
    var _findNodeRecursive;
    if (!selected) return;
    if ((_findNodeRecursive = findNodeRecursive(page.tree, selected)) !== null && _findNodeRecursive !== void 0 && _findNodeRecursive.locked) {
      showToast("Unlock this layer before deleting it");
      return;
    }
    change({
      tree: removeNodeFromTree(page.tree, selected)
    });
    setSelected(null);
    setSelectedElement(null);
    showToast("Deleted block");
  }
  function duplicate() {
    if (!selected) return;
    var loc = findNodeLocation(page.tree, selected);
    if (!loc) return;
    var item = getNodeAt(page.tree, loc.parentId, loc.columnIndex, loc.index);
    if (!item) return;
    var cloned = cloneBlockNode(item);
    change({
      tree: insertNodeAt(page.tree, loc.parentId, loc.columnIndex, loc.index + 1, cloned)
    });
    setSelected(cloned.id);
    setSelectedElement(null);
    showToast("Cloned block");
  }
  function moveBlockBy(direction) {
    if (!selected || direction !== -1 && direction !== 1) return;
    var loc = findNodeLocation(page.tree, selected);
    if (!loc) return;
    var item = getNodeAt(page.tree, loc.parentId, loc.columnIndex, loc.index);
    if (!item) return;
    if (item.locked) {
      showToast("Unlock this layer before moving it");
      return;
    }
    var siblingCount = 0;
    if (loc.parentId == null) {
      siblingCount = page.tree.length;
    } else {
      var _parent$content2;
      var parent = findNodeRecursive(page.tree, loc.parentId);
      siblingCount = (parent === null || parent === void 0 || (_parent$content2 = parent.content) === null || _parent$content2 === void 0 || (_parent$content2 = _parent$content2.columns) === null || _parent$content2 === void 0 || (_parent$content2 = _parent$content2[loc.columnIndex]) === null || _parent$content2 === void 0 ? void 0 : _parent$content2.length) || 0;
    }
    var nextIndex = loc.index + direction;
    if (nextIndex >= 0 && nextIndex < siblingCount) {
      var _nextTree = removeNodeAt(page.tree, loc.parentId, loc.columnIndex, loc.index);
      _nextTree = insertNodeAt(_nextTree, loc.parentId, loc.columnIndex, nextIndex, item);
      change({
        tree: _nextTree
      });
      showToast(direction < 0 ? "Moved up" : "Moved down");
      return;
    }

    // At column/group edge → move block outside next to its parent layout
    if (loc.parentId == null) return;
    var parentLoc = findNodeLocation(page.tree, loc.parentId);
    if (!parentLoc) return;
    var insertIndex = direction < 0 ? parentLoc.index : parentLoc.index + 1;
    var nextTree = removeNodeAt(page.tree, loc.parentId, loc.columnIndex, loc.index);
    nextTree = insertNodeAt(nextTree, parentLoc.parentId, parentLoc.columnIndex, insertIndex, item);
    change({
      tree: nextTree
    });
    showToast(direction < 0 ? "Moved out of column (above)" : "Moved out of column (below)");
  }
  function moveBlockUp() {
    moveBlockBy(-1);
  }
  function moveBlockDown() {
    moveBlockBy(1);
  }
  function moveBlockOutOfColumn() {
    if (!selected) return;
    var loc = findNodeLocation(page.tree, selected);
    if (!loc || loc.parentId == null) return;
    var item = getNodeAt(page.tree, loc.parentId, loc.columnIndex, loc.index);
    if (!item) return;
    if (item.locked) {
      showToast("Unlock this layer before moving it");
      return;
    }
    var parentLoc = findNodeLocation(page.tree, loc.parentId);
    if (!parentLoc) return;
    var nextTree = removeNodeAt(page.tree, loc.parentId, loc.columnIndex, loc.index);
    nextTree = insertNodeAt(nextTree, parentLoc.parentId, parentLoc.columnIndex, parentLoc.index + 1, item);
    change({
      tree: nextTree
    });
    showToast("Moved out of column");
  }
  function ungroup() {
    var _group$content, _children$;
    if (!selected) return;
    var loc = findNodeLocation(page.tree, selected);
    var group = findNodeRecursive(page.tree, selected);
    var children = (group === null || group === void 0 ? void 0 : group.type) === "group" ? ((_group$content = group.content) === null || _group$content === void 0 || (_group$content = _group$content.columns) === null || _group$content === void 0 ? void 0 : _group$content[0]) || [] : [];
    if (!loc || (group === null || group === void 0 ? void 0 : group.type) !== "group") return;
    var nextTree = removeNodeFromTree(page.tree, selected);
    children.forEach(function (child, index) {
      nextTree = insertNodeAt(nextTree, loc.parentId, loc.columnIndex, loc.index + index, child);
    });
    change({
      tree: nextTree
    });
    setSelected(((_children$ = children[0]) === null || _children$ === void 0 ? void 0 : _children$.id) || null);
    setSelectedElement(null);
    showToast("Group ungrouped");
  }
  function copy() {
    var item = findNodeRecursive(page.tree, selected);
    if (item) {
      // Deep snapshot only — fresh ids are assigned on paste so each paste is independent.
      setCopy(cloneBlockNode(item));
      showToast("Block copied — press Ctrl+V or Paste to insert");
    }
  }
  function paste() {
    if (!copyData) {
      showToast("Nothing to paste. Copy a block first.");
      return;
    }

    // Always remap ids again so repeated pastes never share ids with each other.
    var newBlock = cloneBlockNode(copyData);
    var loc = selected ? findNodeLocation(page.tree, selected) : null;
    if (loc) {
      change({
        tree: insertNodeAt(page.tree, loc.parentId, loc.columnIndex, loc.index + 1, newBlock)
      });
      setSelected(newBlock.id);
      setSelectedElement(null);
      showToast("Pasted block below selection");
      return;
    }
    change({
      tree: [].concat(_toConsumableArray(page.tree), [newBlock])
    });
    setSelected(newBlock.id);
    setSelectedElement(null);
    showToast("Pasted block at end");
  }
  useEffect(function () {
    var onKeyDown = function onKeyDown(e) {
      var _target$tagName;
      var target = e.target;
      var tag = target === null || target === void 0 || (_target$tagName = target.tagName) === null || _target$tagName === void 0 ? void 0 : _target$tagName.toLowerCase();
      var isTyping = tag === "input" || tag === "textarea" || (target === null || target === void 0 ? void 0 : target.isContentEditable);
      if (isTyping) {
        return;
      }

      // Escape: climb from nested block → parent column/group, or clear selection
      if (e.key === "Escape" && selected) {
        e.preventDefault();
        var loc = findNodeLocation(page.tree, selected);
        if ((loc === null || loc === void 0 ? void 0 : loc.parentId) != null) {
          setSelected(loc.parentId);
          setSelectedElement(null);
          showToast("Selected parent column");
        } else {
          setSelected(null);
          setSelectedElement(null);
        }
        return;
      }
      var mod = e.ctrlKey || e.metaKey;
      if (!mod) {
        return;
      }
      if (e.key === "v" || e.key === "V") {
        if (!copyData) {
          return;
        }
        e.preventDefault();
        paste();
      }
      if ((e.key === "c" || e.key === "C") && selected) {
        e.preventDefault();
        copy();
      }
      if ((e.key === "d" || e.key === "D") && selected) {
        e.preventDefault();
        duplicate();
      }
    };
    window.addEventListener("keydown", onKeyDown);
    return function () {
      return window.removeEventListener("keydown", onKeyDown);
    };
  });
  function undo() {
    if (!history.length) return;
    var old = history[history.length - 1];
    setHistory(history.slice(0, -1));
    setFuture([page].concat(_toConsumableArray(future)));
    setPage(old);
    showToast("Undo action applied");
  }
  function redo() {
    if (!future.length) return;
    var next = future[0];
    setFuture(future.slice(1));
    setHistory([].concat(_toConsumableArray(history), [page]));
    setPage(next);
    showToast("Redo action applied");
  }
  function editText(v, nodeId) {
    var id = nodeId !== null && nodeId !== void 0 ? nodeId : selected;
    if (!id) return;
    change({
      tree: updateNodeInTree(page.tree, id, function (node) {
        return _objectSpread(_objectSpread({}, node), {}, {
          content: _objectSpread(_objectSpread({}, node.content), {}, {
            text: v
          })
        });
      })
    });
  }
  function editHeadingTag(v) {
    var tagSizes = {
      h1: "32px",
      h2: "24px",
      h3: "20px",
      h4: "16px",
      h5: "14px",
      h6: "12px"
    };
    var defaultSize = tagSizes[v] || "32px";
    patchSelected(function (node) {
      return _objectSpread(_objectSpread({}, node), {}, {
        content: _objectSpread(_objectSpread({}, node.content), {}, {
          tag: v
        }),
        style: _objectSpread(_objectSpread({}, node.style), {}, {
          fontSize: defaultSize
        })
      });
    });
  }
  function editCardTitle(v, nodeId) {
    var id = nodeId !== null && nodeId !== void 0 ? nodeId : selected;
    if (!id) return;
    change({
      tree: updateNodeInTree(page.tree, id, function (node) {
        return _objectSpread(_objectSpread({}, node), {}, {
          content: _objectSpread(_objectSpread({}, node.content), {}, {
            title: v
          })
        });
      })
    });
  }
  function editImageSrc(v) {
    change({
      tree: mapTreeNodes(function (x) {
        return x.id === selected ? _objectSpread(_objectSpread({}, x), {}, {
          content: _objectSpread(_objectSpread({}, x.content), {}, {
            src: v
          })
        }) : x;
      })
    });
  }

  // Paste / upload logic
  function uploadBuilderImage(_x4) {
    return _uploadBuilderImage.apply(this, arguments);
  }
  function _uploadBuilderImage() {
    _uploadBuilderImage = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(file) {
      var _document$querySelect3;
      var allowed, formData, csrfToken, _response$data2, response, url, _err$response;
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            if (file) {
              _context3.next = 2;
              break;
            }
            return _context3.abrupt("return", {
              error: "No file selected"
            });
          case 2:
            allowed = /\.(jpg|jpeg|png|gif|webp)$/i;
            if (allowed.test(file.name)) {
              _context3.next = 5;
              break;
            }
            return _context3.abrupt("return", {
              error: "Only JPG, PNG, GIF, WEBP images are allowed"
            });
          case 5:
            if (!(file.size > 2 * 1024 * 1024)) {
              _context3.next = 7;
              break;
            }
            return _context3.abrupt("return", {
              error: "Image must be 2 MB or less"
            });
          case 7:
            formData = new FormData();
            formData.append("file", file);
            csrfToken = (_document$querySelect3 = document.querySelector('meta[name="csrf-token"]')) === null || _document$querySelect3 === void 0 ? void 0 : _document$querySelect3.getAttribute("content");
            _context3.prev = 10;
            _context3.next = 13;
            return axios.post("/upload_add_more_file", formData, {
              headers: _objectSpread({
                "Content-Type": "multipart/form-data"
              }, csrfToken ? {
                "X-CSRF-TOKEN": csrfToken
              } : {})
            });
          case 13:
            response = _context3.sent;
            url = typeof response.data === "string" ? response.data.trim() : (_response$data2 = response.data) === null || _response$data2 === void 0 ? void 0 : _response$data2.url;
            if (url) {
              _context3.next = 17;
              break;
            }
            return _context3.abrupt("return", {
              error: "Upload failed — no URL returned"
            });
          case 17:
            return _context3.abrupt("return", {
              url: url
            });
          case 20:
            _context3.prev = 20;
            _context3.t0 = _context3["catch"](10);
            return _context3.abrupt("return", {
              error: ((_err$response = _context3.t0.response) === null || _err$response === void 0 || (_err$response = _err$response.data) === null || _err$response === void 0 ? void 0 : _err$response.message) || "Image upload failed"
            });
          case 23:
          case "end":
            return _context3.stop();
        }
      }, _callee3, null, [[10, 20]]);
    }));
    return _uploadBuilderImage.apply(this, arguments);
  }
  function handleImageSrcUpload(_x5) {
    return _handleImageSrcUpload.apply(this, arguments);
  }
  function _handleImageSrcUpload() {
    _handleImageSrcUpload = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(e) {
      var _e$target$files2;
      var file, uploadKey, result;
      return _regeneratorRuntime().wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            file = (_e$target$files2 = e.target.files) === null || _e$target$files2 === void 0 ? void 0 : _e$target$files2[0];
            e.target.value = "";
            if (file) {
              _context4.next = 4;
              break;
            }
            return _context4.abrupt("return");
          case 4:
            uploadKey = "image-src";
            setImageUploadError(null);
            setImageUploading(uploadKey);
            _context4.next = 9;
            return uploadBuilderImage(file);
          case 9:
            result = _context4.sent;
            setImageUploading(null);
            if (!result.error) {
              _context4.next = 14;
              break;
            }
            setImageUploadError({
              key: uploadKey,
              message: result.error
            });
            return _context4.abrupt("return");
          case 14:
            editImageSrc(result.url);
            showToast("Image uploaded successfully");
          case 16:
          case "end":
            return _context4.stop();
        }
      }, _callee4);
    }));
    return _handleImageSrcUpload.apply(this, arguments);
  }
  function handleBackgroundImageUpload(_x6) {
    return _handleBackgroundImageUpload.apply(this, arguments);
  }
  function _handleBackgroundImageUpload() {
    _handleBackgroundImageUpload = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5(e) {
      var _e$target$files3;
      var file, uploadKey, result;
      return _regeneratorRuntime().wrap(function _callee5$(_context5) {
        while (1) switch (_context5.prev = _context5.next) {
          case 0:
            file = (_e$target$files3 = e.target.files) === null || _e$target$files3 === void 0 ? void 0 : _e$target$files3[0];
            e.target.value = "";
            if (file) {
              _context5.next = 4;
              break;
            }
            return _context5.abrupt("return");
          case 4:
            uploadKey = "background-image";
            setImageUploadError(null);
            setImageUploading(uploadKey);
            _context5.next = 9;
            return uploadBuilderImage(file);
          case 9:
            result = _context5.sent;
            setImageUploading(null);
            if (!result.error) {
              _context5.next = 14;
              break;
            }
            setImageUploadError({
              key: uploadKey,
              message: result.error
            });
            return _context5.abrupt("return");
          case 14:
            setBackgroundImageUrl(result.url);
            showToast("Background image uploaded");
          case 16:
          case "end":
            return _context5.stop();
        }
      }, _callee5);
    }));
    return _handleBackgroundImageUpload.apply(this, arguments);
  }
  function handleGalleryImageUpload(_x7, _x8) {
    return _handleGalleryImageUpload.apply(this, arguments);
  }
  function _handleGalleryImageUpload() {
    _handleGalleryImageUpload = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6(index, e) {
      var _e$target$files4;
      var file, uploadKey, result;
      return _regeneratorRuntime().wrap(function _callee6$(_context6) {
        while (1) switch (_context6.prev = _context6.next) {
          case 0:
            file = (_e$target$files4 = e.target.files) === null || _e$target$files4 === void 0 ? void 0 : _e$target$files4[0];
            e.target.value = "";
            if (file) {
              _context6.next = 4;
              break;
            }
            return _context6.abrupt("return");
          case 4:
            uploadKey = "gallery-".concat(index);
            setImageUploadError(null);
            setImageUploading(uploadKey);
            _context6.next = 9;
            return uploadBuilderImage(file);
          case 9:
            result = _context6.sent;
            setImageUploading(null);
            if (!result.error) {
              _context6.next = 14;
              break;
            }
            setImageUploadError({
              key: uploadKey,
              message: result.error
            });
            return _context6.abrupt("return");
          case 14:
            editGalleryImage(index, "src", result.url);
            showToast("Gallery image uploaded");
          case 16:
          case "end":
            return _context6.stop();
        }
      }, _callee6);
    }));
    return _handleGalleryImageUpload.apply(this, arguments);
  }
  function handleLogoImageUpload(_x9, _x10) {
    return _handleLogoImageUpload.apply(this, arguments);
  }
  function _handleLogoImageUpload() {
    _handleLogoImageUpload = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7(index, e) {
      var _e$target$files5;
      var file, uploadKey, result;
      return _regeneratorRuntime().wrap(function _callee7$(_context7) {
        while (1) switch (_context7.prev = _context7.next) {
          case 0:
            file = (_e$target$files5 = e.target.files) === null || _e$target$files5 === void 0 ? void 0 : _e$target$files5[0];
            e.target.value = "";
            if (file) {
              _context7.next = 4;
              break;
            }
            return _context7.abrupt("return");
          case 4:
            uploadKey = "logo-".concat(index);
            setImageUploadError(null);
            setImageUploading(uploadKey);
            _context7.next = 9;
            return uploadBuilderImage(file);
          case 9:
            result = _context7.sent;
            setImageUploading(null);
            if (!result.error) {
              _context7.next = 14;
              break;
            }
            setImageUploadError({
              key: uploadKey,
              message: result.error
            });
            return _context7.abrupt("return");
          case 14:
            editLogo(index, "src", result.url);
            showToast("Logo uploaded");
          case 16:
          case "end":
            return _context7.stop();
        }
      }, _callee7);
    }));
    return _handleLogoImageUpload.apply(this, arguments);
  }
  function handleTestimonialAvatarUpload(_x11, _x12) {
    return _handleTestimonialAvatarUpload.apply(this, arguments);
  }
  function _handleTestimonialAvatarUpload() {
    _handleTestimonialAvatarUpload = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee8(index, e) {
      var _e$target$files6;
      var file, uploadKey, result;
      return _regeneratorRuntime().wrap(function _callee8$(_context8) {
        while (1) switch (_context8.prev = _context8.next) {
          case 0:
            file = (_e$target$files6 = e.target.files) === null || _e$target$files6 === void 0 ? void 0 : _e$target$files6[0];
            e.target.value = "";
            if (file) {
              _context8.next = 4;
              break;
            }
            return _context8.abrupt("return");
          case 4:
            uploadKey = "testimonial-".concat(index);
            setImageUploadError(null);
            setImageUploading(uploadKey);
            _context8.next = 9;
            return uploadBuilderImage(file);
          case 9:
            result = _context8.sent;
            setImageUploading(null);
            if (!result.error) {
              _context8.next = 14;
              break;
            }
            setImageUploadError({
              key: uploadKey,
              message: result.error
            });
            return _context8.abrupt("return");
          case 14:
            editTestimonial(index, "avatar", result.url);
            showToast("Avatar uploaded");
          case 16:
          case "end":
            return _context8.stop();
        }
      }, _callee8);
    }));
    return _handleTestimonialAvatarUpload.apply(this, arguments);
  }
  function setBackgroundImageUrl(url) {
    change({
      tree: mapTreeNodes(function (x) {
        if (x.id !== selected) return x;
        var newStyle = _objectSpread({}, x.style);
        if (!url) {
          delete newStyle.backgroundImage;
          delete newStyle.backgroundSize;
          delete newStyle.backgroundPosition;
          delete newStyle.backgroundRepeat;
          delete newStyle.backgroundOverlayOpacity;
          delete newStyle.backgroundOverlayColor;
        } else {
          newStyle.backgroundImage = "url(\"".concat(url, "\")");
          if (!newStyle.backgroundSize) newStyle.backgroundSize = "cover";
          if (!newStyle.backgroundPosition) newStyle.backgroundPosition = "center";
          if (!newStyle.backgroundRepeat) newStyle.backgroundRepeat = "no-repeat";
          if (newStyle.backgroundOverlayOpacity === undefined || newStyle.backgroundOverlayOpacity === null || newStyle.backgroundOverlayOpacity === "") {
            newStyle.backgroundOverlayOpacity = DEFAULT_BACKGROUND_OVERLAY_OPACITY;
          }
          if (!newStyle.backgroundOverlayColor) {
            newStyle.backgroundOverlayColor = "#000000";
          }
        }
        return _objectSpread(_objectSpread({}, x), {}, {
          style: newStyle
        });
      })
    });
  }
  function editImageAlt(v) {
    change({
      tree: mapTreeNodes(function (x) {
        return x.id === selected ? _objectSpread(_objectSpread({}, x), {}, {
          content: _objectSpread(_objectSpread({}, x.content), {}, {
            alt: v
          })
        }) : x;
      })
    });
  }
  function editImageLink(v) {
    change({
      tree: mapTreeNodes(function (x) {
        return x.id === selected ? _objectSpread(_objectSpread({}, x), {}, {
          content: _objectSpread(_objectSpread({}, x.content), {}, {
            url: v
          })
        }) : x;
      })
    });
  }
  function editButtonLink(v) {
    change({
      tree: mapTreeNodes(function (x) {
        return x.id === selected ? _objectSpread(_objectSpread({}, x), {}, {
          content: _objectSpread(_objectSpread({}, x.content), {}, {
            url: v
          })
        }) : x;
      })
    });
  }
  function editButtonTarget(v) {
    change({
      tree: mapTreeNodes(function (x) {
        return x.id === selected ? _objectSpread(_objectSpread({}, x), {}, {
          content: _objectSpread(_objectSpread({}, x.content), {}, {
            target: v
          })
        }) : x;
      })
    });
  }
  function editHtmlCode(v) {
    change({
      tree: mapTreeNodes(function (x) {
        return x.id === selected ? _objectSpread(_objectSpread({}, x), {}, {
          content: _objectSpread(_objectSpread({}, x.content), {}, {
            code: v
          })
        }) : x;
      })
    });
  }
  function editListItem(index, value) {
    change({
      tree: mapTreeNodes(function (x) {
        if (x.id === selected) {
          var items = _toConsumableArray(x.content.items || []);
          items[index] = value;
          return _objectSpread(_objectSpread({}, x), {}, {
            content: _objectSpread(_objectSpread({}, x.content), {}, {
              items: items
            })
          });
        }
        return x;
      })
    });
  }
  function addListItem() {
    change({
      tree: mapTreeNodes(function (x) {
        if (x.id === selected) {
          var items = [].concat(_toConsumableArray(x.content.items || []), ["New list item"]);
          return _objectSpread(_objectSpread({}, x), {}, {
            content: _objectSpread(_objectSpread({}, x.content), {}, {
              items: items
            })
          });
        }
        return x;
      })
    });
    showToast("Added list item");
  }
  function removeListItem(index) {
    change({
      tree: mapTreeNodes(function (x) {
        if (x.id === selected) {
          var items = (x.content.items || []).filter(function (_, i) {
            return i !== index;
          });
          return _objectSpread(_objectSpread({}, x), {}, {
            content: _objectSpread(_objectSpread({}, x.content), {}, {
              items: items
            })
          });
        }
        return x;
      })
    });
    showToast("Removed list item");
  }
  function editSocialLink(key, value) {
    change({
      tree: mapTreeNodes(function (x) {
        if (x.id === selected) {
          return _objectSpread(_objectSpread({}, x), {}, {
            content: _objectSpread(_objectSpread({}, x.content), {}, _defineProperty({}, key, value))
          });
        }
        return x;
      })
    });
  }
  function editTwoColumnLeft(v) {
    change({
      tree: mapTreeNodes(function (x) {
        return x.id === selected ? _objectSpread(_objectSpread({}, x), {}, {
          content: _objectSpread(_objectSpread({}, x.content), {}, {
            leftText: v
          })
        }) : x;
      })
    });
  }
  function editTwoColumnRight(v) {
    change({
      tree: mapTreeNodes(function (x) {
        return x.id === selected ? _objectSpread(_objectSpread({}, x), {}, {
          content: _objectSpread(_objectSpread({}, x.content), {}, {
            rightText: v
          })
        }) : x;
      })
    });
  }
  function editContentField(field, value) {
    patchSelected(function (node) {
      return _objectSpread(_objectSpread({}, node), {}, {
        content: _objectSpread(_objectSpread({}, node.content), {}, _defineProperty({}, field, value))
      });
    });
  }
  function editIconBlock(patch) {
    patchSelected(function (node) {
      return _objectSpread(_objectSpread({}, node), {}, {
        content: _objectSpread(_objectSpread({}, node.content), patch)
      });
    });
  }
  function signBlockSide(nodeId, side) {
    change({
      tree: mapTreeNodes(function (x) {
        if (x.id !== nodeId) return x;
        if (side === "client") {
          return _objectSpread(_objectSpread({}, x), {}, {
            content: _objectSpread(_objectSpread({}, x.content), {}, {
              clientSigned: true
            })
          });
        }
        return _objectSpread(_objectSpread({}, x), {}, {
          content: _objectSpread(_objectSpread({}, x.content), {}, {
            providerSigned: true
          })
        });
      })
    });
    setSelected(nodeId);
    showToast("Signed — type your signature in the Signature Text field on the right.");
  }
  function editTimelineItem(index, field, value) {
    change({
      tree: mapTreeNodes(function (x) {
        if (x.id !== selected) return x;
        var items = _toConsumableArray(x.content.items || []);
        items[index] = _objectSpread(_objectSpread({}, items[index]), {}, _defineProperty({}, field, value));
        return _objectSpread(_objectSpread({}, x), {}, {
          content: _objectSpread(_objectSpread({}, x.content), {}, {
            items: items
          })
        });
      })
    });
  }
  function addTimelineItem() {
    change({
      tree: mapTreeNodes(function (x) {
        if (x.id !== selected) return x;
        var items = [].concat(_toConsumableArray(x.content.items || []), [{
          title: "New Step",
          date: "",
          description: "Step description details..."
        }]);
        return _objectSpread(_objectSpread({}, x), {}, {
          content: _objectSpread(_objectSpread({}, x.content), {}, {
            items: items
          })
        });
      })
    });
    showToast("Added step / milestone");
  }
  function removeTimelineItem(index) {
    change({
      tree: mapTreeNodes(function (x) {
        if (x.id !== selected) return x;
        var currentItems = x.content.items || [];
        var items = currentItems.filter(function (_, i) {
          return i !== index;
        });
        var nextElementStyles = _objectSpread({}, x.elementStyles || {});
        var removeStylesForObj = function removeStylesForObj(obj) {
          if (!obj || _typeof(obj) !== "object") return;
          var removePrefix = "item_".concat(index, "_");
          var removeExact = "item_".concat(index);
          Object.keys(obj).forEach(function (key) {
            if (key === removeExact || key.startsWith(removePrefix)) {
              delete obj[key];
            }
          });
          var _loop = function _loop() {
            var prefixOld = "item_".concat(k, "_");
            var prefixNew = "item_".concat(k - 1, "_");
            var exactOld = "item_".concat(k);
            var exactNew = "item_".concat(k - 1);
            Object.keys(obj).forEach(function (key) {
              if (key === exactOld) {
                obj[exactNew] = obj[exactOld];
                delete obj[exactOld];
              } else if (key.startsWith(prefixOld)) {
                var suf = key.slice(prefixOld.length);
                obj["".concat(prefixNew).concat(suf)] = obj[key];
                delete obj[key];
              }
            });
          };
          for (var k = index + 1; k < currentItems.length; k++) {
            _loop();
          }
        };
        removeStylesForObj(nextElementStyles);
        var nextResponsiveElementStyles = x.responsiveElementStyles ? JSON.parse(JSON.stringify(x.responsiveElementStyles)) : undefined;
        if (nextResponsiveElementStyles) {
          Object.keys(nextResponsiveElementStyles).forEach(function (vp) {
            removeStylesForObj(nextResponsiveElementStyles[vp]);
          });
        }
        return _objectSpread(_objectSpread({}, x), {}, {
          content: _objectSpread(_objectSpread({}, x.content), {}, {
            items: items
          }),
          elementStyles: nextElementStyles
        }, nextResponsiveElementStyles ? {
          responsiveElementStyles: nextResponsiveElementStyles
        } : {});
      })
    });
    showToast("Removed timeline milestone");
  }
  function duplicateTimelineItem(index) {
    change({
      tree: mapTreeNodes(function (x) {
        if (x.id !== selected) return x;
        var currentItems = x.content.items || [];
        if (!currentItems[index]) return x;
        var cloned = JSON.parse(JSON.stringify(currentItems[index]));
        if (cloned.number && !isNaN(parseInt(cloned.number, 10))) {
          var nextNum = parseInt(cloned.number, 10) + 1;
          cloned.number = cloned.number.startsWith("0") ? String(nextNum).padStart(cloned.number.length, "0") : String(nextNum);
        } else if (cloned.number === undefined) {
          var defaultNext = String(index + 2).padStart(2, "0");
          cloned.number = defaultNext;
        }
        var items = _toConsumableArray(currentItems);
        items.splice(index + 1, 0, cloned);
        var nextElementStyles = _objectSpread({}, x.elementStyles || {});
        var copyStylesForObj = function copyStylesForObj(obj) {
          if (!obj || _typeof(obj) !== "object") return;
          // Shift backwards to avoid overwriting
          var _loop2 = function _loop2() {
            var prefixOld = "item_".concat(k, "_");
            var prefixNew = "item_".concat(k + 1, "_");
            var exactOld = "item_".concat(k);
            var exactNew = "item_".concat(k + 1);
            Object.keys(obj).forEach(function (key) {
              if (key === exactOld) {
                obj[exactNew] = obj[exactOld];
                delete obj[exactOld];
              } else if (key.startsWith(prefixOld)) {
                var suf = key.slice(prefixOld.length);
                obj["".concat(prefixNew).concat(suf)] = obj[key];
                delete obj[key];
              }
            });
          };
          for (var k = currentItems.length - 1; k > index; k--) {
            _loop2();
          }

          // Duplicate styles from source index to index + 1
          var fromPrefix = "item_".concat(index, "_");
          var toPrefix = "item_".concat(index + 1, "_");
          var fromExact = "item_".concat(index);
          var toExact = "item_".concat(index + 1);
          Object.keys(obj).forEach(function (key) {
            if (key === fromExact) {
              obj[toExact] = JSON.parse(JSON.stringify(obj[key]));
            } else if (key.startsWith(fromPrefix)) {
              var suf = key.slice(fromPrefix.length);
              obj["".concat(toPrefix).concat(suf)] = JSON.parse(JSON.stringify(obj[key]));
            }
          });
        };
        copyStylesForObj(nextElementStyles);
        var nextResponsiveElementStyles = x.responsiveElementStyles ? JSON.parse(JSON.stringify(x.responsiveElementStyles)) : undefined;
        if (nextResponsiveElementStyles) {
          Object.keys(nextResponsiveElementStyles).forEach(function (vp) {
            copyStylesForObj(nextResponsiveElementStyles[vp]);
          });
        }
        return _objectSpread(_objectSpread({}, x), {}, {
          content: _objectSpread(_objectSpread({}, x.content), {}, {
            items: items
          }),
          elementStyles: nextElementStyles
        }, nextResponsiveElementStyles ? {
          responsiveElementStyles: nextResponsiveElementStyles
        } : {});
      })
    });
    showToast("Duplicated step / milestone");
  }
  function editThreeColumn(col, value) {
    change({
      tree: mapTreeNodes(function (x) {
        return x.id === selected ? _objectSpread(_objectSpread({}, x), {}, {
          content: _objectSpread(_objectSpread({}, x.content), {}, _defineProperty({}, col, value))
        }) : x;
      })
    });
  }
  function editGalleryImage(index, field, value) {
    change({
      tree: mapTreeNodes(function (x) {
        if (x.id !== selected) return x;
        var images = _toConsumableArray(x.content.images || []);
        images[index] = _objectSpread(_objectSpread({}, images[index]), {}, _defineProperty({}, field, value));
        return _objectSpread(_objectSpread({}, x), {}, {
          content: _objectSpread(_objectSpread({}, x.content), {}, {
            images: images
          })
        });
      })
    });
  }
  function addGalleryImage() {
    change({
      tree: mapTreeNodes(function (x) {
        if (x.id !== selected) return x;
        var images = [].concat(_toConsumableArray(x.content.images || []), [{
          src: "/imgs/New_Templates_Img/image-placeholder.png?random=" + Date.now(),
          alt: "New image"
        }]);
        return _objectSpread(_objectSpread({}, x), {}, {
          content: _objectSpread(_objectSpread({}, x.content), {}, {
            images: images
          })
        });
      })
    });
  }
  function removeGalleryImage(index) {
    change({
      tree: mapTreeNodes(function (x) {
        if (x.id !== selected) return x;
        var images = (x.content.images || []).filter(function (_, i) {
          return i !== index;
        });
        return _objectSpread(_objectSpread({}, x), {}, {
          content: _objectSpread(_objectSpread({}, x.content), {}, {
            images: images
          })
        });
      })
    });
  }
  function editLogo(index, field, value) {
    change({
      tree: mapTreeNodes(function (x) {
        if (x.id !== selected) return x;
        var logos = _toConsumableArray(x.content.logos || []);
        logos[index] = _objectSpread(_objectSpread({}, logos[index]), {}, _defineProperty({}, field, value));
        return _objectSpread(_objectSpread({}, x), {}, {
          content: _objectSpread(_objectSpread({}, x.content), {}, {
            logos: logos
          })
        });
      })
    });
  }
  function addLogo() {
    change({
      tree: mapTreeNodes(function (x) {
        if (x.id !== selected) return x;
        var logos = [].concat(_toConsumableArray(x.content.logos || []), [{
          src: "https://placehold.co/120x40/e2e8f0/475569.png?text=Brand&random=" + Date.now(),
          alt: "Brand"
        }]);
        return _objectSpread(_objectSpread({}, x), {}, {
          content: _objectSpread(_objectSpread({}, x.content), {}, {
            logos: logos
          })
        });
      })
    });
  }
  function removeLogo(index) {
    change({
      tree: mapTreeNodes(function (x) {
        if (x.id !== selected) return x;
        var logos = (x.content.logos || []).filter(function (_, i) {
          return i !== index;
        });
        return _objectSpread(_objectSpread({}, x), {}, {
          content: _objectSpread(_objectSpread({}, x.content), {}, {
            logos: logos
          })
        });
      })
    });
  }
  function editAccordionItem(index, field, value) {
    change({
      tree: mapTreeNodes(function (x) {
        if (x.id !== selected) return x;
        var items = _toConsumableArray(x.content.items || []);
        items[index] = _objectSpread(_objectSpread({}, items[index]), {}, _defineProperty({}, field, value));
        return _objectSpread(_objectSpread({}, x), {}, {
          content: _objectSpread(_objectSpread({}, x.content), {}, {
            items: items
          })
        });
      })
    });
  }
  function addAccordionItem() {
    change({
      tree: mapTreeNodes(function (x) {
        if (x.id !== selected) return x;
        var items = [].concat(_toConsumableArray(x.content.items || []), [{
          title: "New question?",
          body: "Answer goes here."
        }]);
        return _objectSpread(_objectSpread({}, x), {}, {
          content: _objectSpread(_objectSpread({}, x.content), {}, {
            items: items
          })
        });
      })
    });
  }

  // Remove accordion item
  function removeAccordionItem(index) {
    change({
      tree: mapTreeNodes(function (x) {
        if (x.id !== selected) return x;
        var items = (x.content.items || []).filter(function (_, i) {
          return i !== index;
        });
        return _objectSpread(_objectSpread({}, x), {}, {
          content: _objectSpread(_objectSpread({}, x.content), {}, {
            items: items,
            openIndex: 0
          })
        });
      })
    });
  }
  function editPricingPlan(index, field, value) {
    change({
      tree: mapTreeNodes(function (x) {
        if (x.id !== selected) return x;
        var plans = _toConsumableArray(x.content.plans || []);
        plans[index] = _objectSpread(_objectSpread({}, plans[index]), {}, _defineProperty({}, field, value));
        return _objectSpread(_objectSpread({}, x), {}, {
          content: _objectSpread(_objectSpread({}, x.content), {}, {
            plans: plans
          })
        });
      })
    });
  }
  function editPricingFeature(planIndex, featureIndex, value) {
    change({
      tree: mapTreeNodes(function (x) {
        if (x.id !== selected) return x;
        var plans = _toConsumableArray(x.content.plans || []);
        var features = _toConsumableArray(plans[planIndex].features || []);
        features[featureIndex] = value;
        plans[planIndex] = _objectSpread(_objectSpread({}, plans[planIndex]), {}, {
          features: features
        });
        return _objectSpread(_objectSpread({}, x), {}, {
          content: _objectSpread(_objectSpread({}, x.content), {}, {
            plans: plans
          })
        });
      })
    });
  }
  function addPricingFeature(planIndex) {
    change({
      tree: mapTreeNodes(function (x) {
        if (x.id !== selected) return x;
        var plans = _toConsumableArray(x.content.plans || []);
        var features = [].concat(_toConsumableArray(plans[planIndex].features || []), ["New feature"]);
        plans[planIndex] = _objectSpread(_objectSpread({}, plans[planIndex]), {}, {
          features: features
        });
        return _objectSpread(_objectSpread({}, x), {}, {
          content: _objectSpread(_objectSpread({}, x.content), {}, {
            plans: plans
          })
        });
      })
    });
    showToast("Added feature");
  }
  function removePricingFeature(planIndex, featureIndex) {
    change({
      tree: mapTreeNodes(function (x) {
        if (x.id !== selected) return x;
        var plans = _toConsumableArray(x.content.plans || []);
        var features = (plans[planIndex].features || []).filter(function (_, i) {
          return i !== featureIndex;
        });
        plans[planIndex] = _objectSpread(_objectSpread({}, plans[planIndex]), {}, {
          features: features
        });
        return _objectSpread(_objectSpread({}, x), {}, {
          content: _objectSpread(_objectSpread({}, x.content), {}, {
            plans: plans
          })
        });
      })
    });
    showToast("Removed feature");
  }
  function addPricingPlan() {
    change({
      tree: mapTreeNodes(function (x) {
        if (x.id !== selected) return x;
        var plans = _toConsumableArray(x.content.plans || []);
        plans.push({
          name: "Plan ".concat(plans.length + 1),
          price: "$29",
          period: "/mo",
          features: ["Feature 1", "Feature 2"],
          highlighted: false,
          buttonText: "Choose Plan"
        });
        return _objectSpread(_objectSpread({}, x), {}, {
          content: _objectSpread(_objectSpread({}, x.content), {}, {
            plans: plans
          })
        });
      })
    });
    showToast("Added pricing plan");
  }
  function removePricingPlan(index) {
    change({
      tree: mapTreeNodes(function (x) {
        if (x.id !== selected) return x;
        var plans = (x.content.plans || []).filter(function (_, i) {
          return i !== index;
        });
        return _objectSpread(_objectSpread({}, x), {}, {
          content: _objectSpread(_objectSpread({}, x.content), {}, {
            plans: plans
          })
        });
      })
    });
    showToast("Removed pricing plan");
  }
  function editTestimonial(index, field, value) {
    change({
      tree: mapTreeNodes(function (x) {
        if (x.id !== selected) return x;
        var items = _toConsumableArray(x.content.items || []);
        items[index] = _objectSpread(_objectSpread({}, items[index]), {}, _defineProperty({}, field, value));
        return _objectSpread(_objectSpread({}, x), {}, {
          content: _objectSpread(_objectSpread({}, x.content), {}, {
            items: items
          })
        });
      })
    });
  }
  function addTestimonial() {
    change({
      tree: mapTreeNodes(function (x) {
        if (x.id !== selected) return x;
        var items = [].concat(_toConsumableArray(x.content.items || []), [{
          quote: "Great product!",
          name: "Client Name",
          role: "Job Title",
          rating: 5,
          avatar: IMAGE_PLACEHOLDER_SRC
        }]);
        return _objectSpread(_objectSpread({}, x), {}, {
          content: _objectSpread(_objectSpread({}, x.content), {}, {
            items: items
          })
        });
      })
    });
  }
  function removeTestimonial(index) {
    change({
      tree: mapTreeNodes(function (x) {
        if (x.id !== selected) return x;
        var items = (x.content.items || []).filter(function (_, i) {
          return i !== index;
        });
        return _objectSpread(_objectSpread({}, x), {}, {
          content: _objectSpread(_objectSpread({}, x.content), {}, {
            items: items
          })
        });
      })
    });
  }
  function editTableHeader(colIndex, v) {
    change({
      tree: mapTreeNodes(function (x) {
        if (x.id === selected) {
          var headers = _toConsumableArray(x.content.headers || []);
          headers[colIndex] = v;
          return _objectSpread(_objectSpread({}, x), {}, {
            content: _objectSpread(_objectSpread({}, x.content), {}, {
              headers: headers
            })
          });
        }
        return x;
      })
    });
  }
  function editTableCell(rowIndex, colIndex, v) {
    change({
      tree: mapTreeNodes(function (x) {
        if (x.id === selected) {
          var rows = _toConsumableArray(x.content.rows || []);
          rows[rowIndex] = _toConsumableArray(rows[rowIndex] || []);
          rows[rowIndex][colIndex] = v;
          return _objectSpread(_objectSpread({}, x), {}, {
            content: _objectSpread(_objectSpread({}, x.content), {}, {
              rows: rows
            })
          });
        }
        return x;
      })
    });
  }
  function addTableRow() {
    change({
      tree: mapTreeNodes(function (x) {
        if (x.id === selected) {
          var headers = x.content.headers || [];
          var newRow = new Array(headers.length).fill("New Cell");
          var rows = [].concat(_toConsumableArray(x.content.rows || []), [newRow]);
          return _objectSpread(_objectSpread({}, x), {}, {
            content: _objectSpread(_objectSpread({}, x.content), {}, {
              rows: rows
            })
          });
        }
        return x;
      })
    });
  }
  function addTableColumn() {
    change({
      tree: mapTreeNodes(function (x) {
        if (x.id === selected) {
          var headers = [].concat(_toConsumableArray(x.content.headers || []), ["New Col"]);
          var rows = (x.content.rows || []).map(function (r) {
            return [].concat(_toConsumableArray(r), ["New Cell"]);
          });
          return _objectSpread(_objectSpread({}, x), {}, {
            content: _objectSpread(_objectSpread({}, x.content), {}, {
              headers: headers,
              rows: rows
            })
          });
        }
        return x;
      })
    });
  }
  function addLayoutColumn() {
    if (!selected) return;
    var target = findNodeRecursive(page.tree, selected);
    if (!target || !isColumnLayoutType(target.type) || target.locked) return;
    var cols;
    if (isNestedColumnContent(target.content)) {
      cols = _toConsumableArray(target.content.columns || []);
    } else if (target.type === "two-column") {
      var _target$content, _target$content2;
      cols = [(_target$content = target.content) !== null && _target$content !== void 0 && _target$content.leftText ? [{
        id: createUniqueBlockId(),
        type: "text",
        content: {
          text: target.content.leftText
        },
        style: {}
      }] : [], (_target$content2 = target.content) !== null && _target$content2 !== void 0 && _target$content2.rightText ? [{
        id: createUniqueBlockId(),
        type: "text",
        content: {
          text: target.content.rightText
        },
        style: {}
      }] : []];
    } else if (target.type === "one-column") {
      var _target$content3;
      cols = [(_target$content3 = target.content) !== null && _target$content3 !== void 0 && _target$content3.col1 ? [{
        id: createUniqueBlockId(),
        type: "text",
        content: {
          text: target.content.col1
        },
        style: {}
      }] : []];
    } else {
      cols = ["col1", "col2", "col3"].map(function (key) {
        var _target$content4;
        return (_target$content4 = target.content) !== null && _target$content4 !== void 0 && _target$content4[key] ? [{
          id: createUniqueBlockId(),
          type: "text",
          content: {
            text: target.content[key]
          },
          style: {}
        }] : [];
      });
    }
    if (cols.length >= MAX_LAYOUT_COLUMNS) {
      showToast("Maximum ".concat(MAX_LAYOUT_COLUMNS, " columns allowed"));
      return;
    }
    cols = [].concat(_toConsumableArray(cols), [[]]);
    var nextStyle = mapColumnStyleArrays(target.style, function (arr) {
      while (arr.length < cols.length - 1) arr.push("");
      arr.push("");
      return arr;
    });
    patchSelected(function (node) {
      return _objectSpread(_objectSpread({}, node), {}, {
        type: getColumnLayoutType(cols.length),
        content: {
          columns: cols
        },
        style: nextStyle
      });
    });
    showToast("Column added");
  }
  function duplicateLayoutColumn(columnIndex) {
    if (!selected) return;
    var target = findNodeRecursive(page.tree, selected);
    if (!target || !isColumnLayoutType(target.type) || target.locked) return;
    var cols;
    if (isNestedColumnContent(target.content)) {
      cols = _toConsumableArray(target.content.columns || []);
    } else if (target.type === "two-column") {
      var _target$content5, _target$content6;
      cols = [(_target$content5 = target.content) !== null && _target$content5 !== void 0 && _target$content5.leftText ? [{
        id: createUniqueBlockId(),
        type: "text",
        content: {
          text: target.content.leftText
        },
        style: {}
      }] : [], (_target$content6 = target.content) !== null && _target$content6 !== void 0 && _target$content6.rightText ? [{
        id: createUniqueBlockId(),
        type: "text",
        content: {
          text: target.content.rightText
        },
        style: {}
      }] : []];
    } else if (target.type === "one-column") {
      var _target$content7;
      cols = [(_target$content7 = target.content) !== null && _target$content7 !== void 0 && _target$content7.col1 ? [{
        id: createUniqueBlockId(),
        type: "text",
        content: {
          text: target.content.col1
        },
        style: {}
      }] : []];
    } else {
      cols = ["col1", "col2", "col3"].map(function (key) {
        var _target$content8;
        return (_target$content8 = target.content) !== null && _target$content8 !== void 0 && _target$content8[key] ? [{
          id: createUniqueBlockId(),
          type: "text",
          content: {
            text: target.content[key]
          },
          style: {}
        }] : [];
      });
    }
    if (cols.length >= MAX_LAYOUT_COLUMNS) {
      showToast("Maximum ".concat(MAX_LAYOUT_COLUMNS, " columns allowed"));
      return;
    }
    var sourceIndex = typeof columnIndex === "number" ? columnIndex : cols.length - 1;
    if (sourceIndex < 0 || sourceIndex >= cols.length) return;
    var sourceBlocks = Array.isArray(cols[sourceIndex]) ? cols[sourceIndex] : [];
    var clonedBlocks = sourceBlocks.map(function (block) {
      return cloneBlockNode(block);
    }).filter(Boolean);
    var nextCols = _toConsumableArray(cols);
    nextCols.splice(sourceIndex + 1, 0, clonedBlocks);
    var nextStyle = mapColumnStyleArrays(target.style, function (arr) {
      while (arr.length < cols.length) arr.push("");
      var sourceVal = arr[sourceIndex] || "";
      arr.splice(sourceIndex + 1, 0, sourceVal);
      return arr;
    });
    patchSelected(function (node) {
      return _objectSpread(_objectSpread({}, node), {}, {
        type: getColumnLayoutType(nextCols.length),
        content: {
          columns: nextCols
        },
        style: nextStyle
      });
    });
    showToast("Column ".concat(sourceIndex + 1, " duplicated with design"));
  }
  function removeLayoutColumn(columnIndex) {
    if (!selected) return;
    var target = findNodeRecursive(page.tree, selected);
    if (!target || !isColumnLayoutType(target.type) || !isNestedColumnContent(target.content) || target.locked) return;
    var cols = _toConsumableArray(target.content.columns || []);
    if (cols.length <= MIN_LAYOUT_COLUMNS) {
      showToast("Minimum ".concat(MIN_LAYOUT_COLUMNS, " columns required"));
      return;
    }
    var removeAt = typeof columnIndex === "number" ? columnIndex : cols.length - 1;
    if (removeAt < 0 || removeAt >= cols.length) return;
    cols.splice(removeAt, 1);
    var nextStyle = mapColumnStyleArrays(target.style, function (arr) {
      return arr.filter(function (_, i) {
        return i !== removeAt;
      });
    });
    patchSelected(function (node) {
      return _objectSpread(_objectSpread({}, node), {}, {
        type: getColumnLayoutType(cols.length),
        content: {
          columns: cols
        },
        style: nextStyle
      });
    });
    showToast("Column ".concat(removeAt + 1, " deleted"));
  }
  function duplicateTableRow(rowIndex) {
    change({
      tree: mapTreeNodes(function (x) {
        if (x.id === selected && x.type === "table") {
          var _x$content;
          var currentRows = ((_x$content = x.content) === null || _x$content === void 0 ? void 0 : _x$content.rows) || [];
          if (!currentRows[rowIndex]) return x;
          var clonedRow = JSON.parse(JSON.stringify(currentRows[rowIndex]));
          var rows = _toConsumableArray(currentRows);
          rows.splice(rowIndex + 1, 0, clonedRow);
          var nextElementStyles = _objectSpread({}, x.elementStyles || {});
          var copyStylesForObj = function copyStylesForObj(obj) {
            if (!obj || _typeof(obj) !== "object") return;
            // Shift styles for subsequent rows downwards from last row down to rowIndex + 1
            var _loop3 = function _loop3(r) {
              Object.keys(obj).forEach(function (key) {
                var match = key.match(new RegExp("^cell_".concat(r, "_(\\d+)$")));
                if (match) {
                  var cI = match[1];
                  var oldKey = "cell_".concat(r, "_").concat(cI);
                  var newKey = "cell_".concat(r + 1, "_").concat(cI);
                  obj[newKey] = obj[oldKey];
                  delete obj[oldKey];
                }
              });
            };
            for (var r = currentRows.length - 1; r > rowIndex; r--) {
              _loop3(r);
            }

            // Duplicate styles from rowIndex to rowIndex + 1
            Object.keys(obj).forEach(function (key) {
              var match = key.match(new RegExp("^cell_".concat(rowIndex, "_(\\d+)$")));
              if (match) {
                var cI = match[1];
                var srcKey = "cell_".concat(rowIndex, "_").concat(cI);
                var destKey = "cell_".concat(rowIndex + 1, "_").concat(cI);
                obj[destKey] = JSON.parse(JSON.stringify(obj[srcKey]));
              }
            });
          };
          copyStylesForObj(nextElementStyles);
          var nextResponsiveElementStyles = x.responsiveElementStyles ? JSON.parse(JSON.stringify(x.responsiveElementStyles)) : undefined;
          if (nextResponsiveElementStyles) {
            Object.keys(nextResponsiveElementStyles).forEach(function (vp) {
              copyStylesForObj(nextResponsiveElementStyles[vp]);
            });
          }
          return _objectSpread(_objectSpread({}, x), {}, {
            content: _objectSpread(_objectSpread({}, x.content), {}, {
              rows: rows
            }),
            elementStyles: nextElementStyles
          }, nextResponsiveElementStyles ? {
            responsiveElementStyles: nextResponsiveElementStyles
          } : {});
        }
        return x;
      })
    });
    showToast("Row ".concat(rowIndex + 1, " duplicated with styles"));
  }
  function removeTableRow(rowIndex) {
    change({
      tree: mapTreeNodes(function (x) {
        if (x.id === selected && x.type === "table") {
          var _x$content2;
          var currentRows = ((_x$content2 = x.content) === null || _x$content2 === void 0 ? void 0 : _x$content2.rows) || [];
          if (!currentRows[rowIndex]) return x;
          var rows = currentRows.filter(function (_, i) {
            return i !== rowIndex;
          });
          var nextElementStyles = _objectSpread({}, x.elementStyles || {});
          var cleanAndShiftForObj = function cleanAndShiftForObj(obj) {
            if (!obj || _typeof(obj) !== "object") return;
            // Delete styles for deleted row
            Object.keys(obj).forEach(function (key) {
              if (key.match(new RegExp("^cell_".concat(rowIndex, "_(\\d+)$")))) {
                delete obj[key];
              }
            });
            // Shift styles for subsequent rows upwards
            var _loop4 = function _loop4(r) {
              Object.keys(obj).forEach(function (key) {
                var match = key.match(new RegExp("^cell_".concat(r, "_(\\d+)$")));
                if (match) {
                  var cI = match[1];
                  var oldKey = "cell_".concat(r, "_").concat(cI);
                  var newKey = "cell_".concat(r - 1, "_").concat(cI);
                  obj[newKey] = obj[oldKey];
                  delete obj[oldKey];
                }
              });
            };
            for (var r = rowIndex + 1; r < currentRows.length; r++) {
              _loop4(r);
            }
          };
          cleanAndShiftForObj(nextElementStyles);
          var nextResponsiveElementStyles = x.responsiveElementStyles ? JSON.parse(JSON.stringify(x.responsiveElementStyles)) : undefined;
          if (nextResponsiveElementStyles) {
            Object.keys(nextResponsiveElementStyles).forEach(function (vp) {
              cleanAndShiftForObj(nextResponsiveElementStyles[vp]);
            });
          }
          return _objectSpread(_objectSpread({}, x), {}, {
            content: _objectSpread(_objectSpread({}, x.content), {}, {
              rows: rows
            }),
            elementStyles: nextElementStyles
          }, nextResponsiveElementStyles ? {
            responsiveElementStyles: nextResponsiveElementStyles
          } : {});
        }
        return x;
      })
    });
    showToast("Row ".concat(rowIndex + 1, " removed"));
  }
  function removeTableColumn(colIndex) {
    change({
      tree: mapTreeNodes(function (x) {
        if (x.id === selected && x.type === "table") {
          var headers = (x.content.headers || []).filter(function (_, i) {
            return i !== colIndex;
          });
          var rows = (x.content.rows || []).map(function (r) {
            return r.filter(function (_, i) {
              return i !== colIndex;
            });
          });
          var nextElementStyles = _objectSpread({}, x.elementStyles || {});
          var cleanAndShiftColStyles = function cleanAndShiftColStyles(obj) {
            if (!obj || _typeof(obj) !== "object") return;
            if (obj["header_".concat(colIndex)]) delete obj["header_".concat(colIndex)];
            for (var c = colIndex + 1; c <= (x.content.headers || []).length; c++) {
              if (obj["header_".concat(c)]) {
                obj["header_".concat(c - 1)] = obj["header_".concat(c)];
                delete obj["header_".concat(c)];
              }
            }
            Object.keys(obj).forEach(function (key) {
              var match = key.match(/^cell_(\d+)_(\d+)$/);
              if (match) {
                var r = match[1];
                var _c = parseInt(match[2], 10);
                if (_c === colIndex) {
                  delete obj[key];
                }
              }
            });
            var _loop5 = function _loop5(_c2) {
              Object.keys(obj).forEach(function (key) {
                var match = key.match(new RegExp("^cell_(\\d+)_".concat(_c2, "$")));
                if (match) {
                  var r = match[1];
                  var oldKey = "cell_".concat(r, "_").concat(_c2);
                  var newKey = "cell_".concat(r, "_").concat(_c2 - 1);
                  obj[newKey] = obj[oldKey];
                  delete obj[oldKey];
                }
              });
            };
            for (var _c2 = colIndex + 1; _c2 <= (x.content.headers || []).length; _c2++) {
              _loop5(_c2);
            }
          };
          cleanAndShiftColStyles(nextElementStyles);
          var nextResponsiveElementStyles = x.responsiveElementStyles ? JSON.parse(JSON.stringify(x.responsiveElementStyles)) : undefined;
          if (nextResponsiveElementStyles) {
            Object.keys(nextResponsiveElementStyles).forEach(function (vp) {
              cleanAndShiftColStyles(nextResponsiveElementStyles[vp]);
            });
          }
          return _objectSpread(_objectSpread({}, x), {}, {
            content: _objectSpread(_objectSpread({}, x.content), {}, {
              headers: headers,
              rows: rows
            }),
            elementStyles: nextElementStyles
          }, nextResponsiveElementStyles ? {
            responsiveElementStyles: nextResponsiveElementStyles
          } : {});
        }
        return x;
      })
    });
    showToast("Column ".concat(colIndex + 1, " deleted"));
  }
  function css(k, v) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    applyStylePatch(function (current, node) {
      var next = _objectSpread(_objectSpread({}, current), {}, _defineProperty({}, k, v));
      // Panel uses borderStyle/Width/Color — remove shorthand so it doesn't override them
      if (k === "borderStyle" || k === "borderWidth" || k === "borderColor") {
        delete next.border;
        if (k === "borderStyle" && v && v !== "none") {
          var hasPerSide = ["Top", "Right", "Bottom", "Left"].some(function (side) {
            return next["border".concat(side, "Width")] !== undefined;
          });
          if (!hasPerSide && (!next.borderWidth || next.borderWidth === "0px")) next.borderWidth = "1px";
          if (!next.borderColor) next.borderColor = "#101828";
        }
        if (k === "borderWidth") {
          ["Top", "Right", "Bottom", "Left"].forEach(function (side) {
            delete next["border".concat(side, "Width")];
            delete next["border".concat(side, "Style")];
          });
        }
      }
      if (/^border(Top|Right|Bottom|Left)(Width|Style)$/.test(k)) {
        delete next.border;
      }
      if (k === "color" && node && !isColumnLayoutType(node.type) && !selectedElement) {
        next.useCustomTextColor = true;
      }
      if (k === "innerBorderStyle" && v && v !== "none") {
        if (!next.innerBorderWidth || next.innerBorderWidth === "0px") next.innerBorderWidth = "1px";
        if (!next.innerBorderColor) next.innerBorderColor = "#d4af37";
        if (!next.innerBorderInset) next.innerBorderInset = "24px";
        var hasPad = next.padding !== undefined && next.padding !== null && next.padding !== "" && next.padding !== "0px" || hasIndividualSpacing(next, "padding");
        if (!hasPad) {
          var inset = parseInt(next.innerBorderInset, 10) || 24;
          next.padding = "".concat(inset + 16, "px");
        }
      }
      return next;
    }, options);
  }
  function patchBlockSpacing(property, styleUpdater) {
    if (!selected) return;
    patchSelected(function (node) {
      var _lifted$responsiveSty;
      var lifted = liftElementSpacingToBlock(node, property);
      var current = _objectSpread(_objectSpread({}, lifted.style || {}), viewport === "desktop" ? {} : ((_lifted$responsiveSty = lifted.responsiveStyles) === null || _lifted$responsiveSty === void 0 ? void 0 : _lifted$responsiveSty[viewport]) || {});
      var nextStyle = styleUpdater(_objectSpread({}, current), lifted);
      if (viewport !== "desktop") {
        return liftElementSpacingToBlock(_objectSpread(_objectSpread({}, lifted), {}, {
          responsiveStyles: _objectSpread(_objectSpread({}, lifted.responsiveStyles || {}), {}, _defineProperty({}, viewport, nextStyle))
        }), property);
      }
      return liftElementSpacingToBlock(_objectSpread(_objectSpread({}, lifted), {}, {
        style: nextStyle
      }), property);
    });
  }
  function updateSpacing(property, side, value) {
    var unit = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : "px";
    var allowNegative = property === "margin";
    var cssVal = formatCssLength(value, unit, {
      allowNegative: allowNegative
    });
    patchBlockSpacing(property, function (newStyle) {
      // Expand shorthand first so editing one side doesn't wipe the other three
      if (!hasIndividualSpacing(newStyle, property)) {
        var _parseCssLength = parseCssLength(newStyle[property], 0, unit),
          sharedValue = _parseCssLength.value,
          sharedUnit = _parseCssLength.unit;
        var expanded = formatCssLength(sharedValue, sharedUnit, {
          allowNegative: allowNegative
        });
        SPACING_SIDES.forEach(function (s) {
          newStyle[property + s.key] = expanded;
        });
      }
      delete newStyle[property];
      newStyle[property + side] = cssVal;
      return newStyle;
    });
  }
  function updateSpacingAll(property, value) {
    var unit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "px";
    var allowNegative = property === "margin";
    var cssVal = formatCssLength(value, unit, {
      allowNegative: allowNegative
    });
    patchBlockSpacing(property, function (newStyle) {
      newStyle[property] = cssVal;
      SPACING_SIDES.forEach(function (s) {
        return delete newStyle[property + s.key];
      });
      return newStyle;
    });
  }
  function toggleSpacingMode(property) {
    patchBlockSpacing(property, function (newStyle) {
      var allowNegative = property === "margin";
      if (hasIndividualSpacing(newStyle, property)) {
        var top = getSpacingSideValue(newStyle, property, "Top");
        var unit = parseCssLength(newStyle[property + "Top"] || "".concat(top, "px")).unit;
        newStyle[property] = formatCssLength(top, unit, {
          allowNegative: allowNegative
        });
        SPACING_SIDES.forEach(function (s) {
          return delete newStyle[property + s.key];
        });
      } else {
        var _parseCssLength2 = parseCssLength(newStyle[property], 0),
          value = _parseCssLength2.value,
          _unit = _parseCssLength2.unit;
        delete newStyle[property];
        SPACING_SIDES.forEach(function (s) {
          newStyle[property + s.key] = formatCssLength(value, _unit, {
            allowNegative: allowNegative
          });
        });
      }
      return newStyle;
    });
  }
  function updateSize(property, value) {
    var unit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "auto";
    applyStylePatch(function (newStyle) {
      newStyle[property] = formatCssLength(value, unit);
      return newStyle;
    }, {
      blockOnly: true
    });
  }
  function updateOffset(sideKey, value) {
    var unit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "px";
    applyStylePatch(function (newStyle) {
      newStyle[sideKey] = formatCssLength(value, unit, {
        allowNegative: true
      });
      if (!newStyle.position || newStyle.position === "static") {
        newStyle.position = "relative";
      }
      return newStyle;
    }, {
      blockOnly: true
    });
  }
  function updatePosition(value) {
    applyStylePatch(function (newStyle) {
      newStyle.position = value || "static";
      if (value === "static") {
        delete newStyle.top;
        delete newStyle.right;
        delete newStyle.bottom;
        delete newStyle.left;
        delete newStyle.zIndex;
      }
      return newStyle;
    }, {
      blockOnly: true
    });
  }
  function updateZIndex(value) {
    applyStylePatch(function (newStyle) {
      if (value === "" || value == null) {
        delete newStyle.zIndex;
      } else {
        newStyle.zIndex = parseInt(value, 10) || 0;
      }
      return newStyle;
    }, {
      blockOnly: true
    });
  }
  function updateRadiusCorner(cornerKey, value) {
    var unit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "px";
    var css = formatCssLength(value, unit);
    applyStylePatch(function (newStyle) {
      delete newStyle.borderRadius;
      newStyle[cornerKey] = css;
      return newStyle;
    });
  }
  function updateColumnBackground(index, color) {
    var columnCount = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 2;
    updateColumnStyleValue(index, "columnBackgrounds", color && color !== "transparent" ? color : "", columnCount);
  }
  function updateColumnStyleValue(index, key, value) {
    var columnCount = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 2;
    applyStylePatch(function (newStyle) {
      var arr = ensureColumnStyleArray(newStyle, key, columnCount);
      arr[index] = value || "";
      newStyle[key] = arr;
      return newStyle;
    });
  }
  function updateColumnStyleValues(index, updates) {
    var columnCount = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 2;
    applyStylePatch(function (newStyle) {
      Object.entries(updates).forEach(function (_ref9) {
        var _ref10 = _slicedToArray(_ref9, 2),
          key = _ref10[0],
          value = _ref10[1];
        var arr = ensureColumnStyleArray(newStyle, key, columnCount);
        arr[index] = value || "";
        newStyle[key] = arr;
      });
      return newStyle;
    });
  }
  function updateImageShape(shape) {
    applyStylePatch(function (newStyle) {
      if (shape === "circle") {
        newStyle.imageShape = "circle";
        newStyle.borderRadius = "50%";
        RADIUS_CORNERS.forEach(function (c) {
          return delete newStyle[c.key];
        });
        delete newStyle.height;
        if (!newStyle.width || newStyle.width === "auto" || newStyle.width === "100%") {
          newStyle.width = "40%";
        }
      } else {
        newStyle.imageShape = "rectangle";
        newStyle.borderRadius = "0";
        RADIUS_CORNERS.forEach(function (c) {
          return delete newStyle[c.key];
        });
      }
      return newStyle;
    });
  }

  // Radius Controls All
  function updateRadiusAll(value) {
    var unit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "px";
    var css = formatCssLength(value, unit);
    applyStylePatch(function (newStyle) {
      newStyle.borderRadius = css;
      RADIUS_CORNERS.forEach(function (c) {
        return delete newStyle[c.key];
      });
      return newStyle;
    });
  }
  function toggleRadiusMode() {
    applyStylePatch(function (newStyle) {
      if (hasIndividualRadius(newStyle)) {
        var _getRadiusCornerLengt = getRadiusCornerLength(newStyle, "borderTopLeftRadius"),
          value = _getRadiusCornerLengt.value,
          unit = _getRadiusCornerLengt.unit;
        newStyle.borderRadius = formatCssLength(value, unit);
        RADIUS_CORNERS.forEach(function (c) {
          return delete newStyle[c.key];
        });
      } else {
        var _getRadiusCornerLengt2 = getRadiusCornerLength(newStyle, "borderTopLeftRadius"),
          _value = _getRadiusCornerLengt2.value,
          _unit2 = _getRadiusCornerLengt2.unit;
        delete newStyle.borderRadius;
        RADIUS_CORNERS.forEach(function (c) {
          newStyle[c.key] = formatCssLength(_value, _unit2);
        });
      }
      return newStyle;
    });
  }
  function clearCanvas() {
    triggerConfirm("Are you sure you want to clear the canvas? This action cannot be undone.", function () {
      change({
        tree: []
      });
      setSelected(null);
      setSelectedElement(null);
      showToast("Canvas cleared");
    });
  }
  function requestPdfDownload() {
    return _requestPdfDownload.apply(this, arguments);
  }
  function _requestPdfDownload() {
    _requestPdfDownload = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee9() {
      var _document$querySelect4, _document$getElementB;
      var mode,
        rawHtml,
        csrfToken,
        isPaged,
        titleFallback,
        _response$headers,
        response,
        blob,
        url,
        a,
        _err$response2,
        message,
        text,
        json,
        parts,
        _err$response3,
        data,
        _parts,
        _args9 = arguments;
      return _regeneratorRuntime().wrap(function _callee9$(_context9) {
        while (1) switch (_context9.prev = _context9.next) {
          case 0:
            mode = _args9.length > 0 && _args9[0] !== undefined ? _args9[0] : "single";
            // Use the same canvas export HTML for both modes so design matches the editor.
            rawHtml = generateHtml(page.tree, globalFont || getTreeFontFamily(page.tree), globalBackgroundColor || "#FFFFFF", documentPadding, documentPageSize, globalBackgroundImage || "");
            csrfToken = (_document$querySelect4 = document.querySelector('meta[name="csrf-token"]')) === null || _document$querySelect4 === void 0 ? void 0 : _document$querySelect4.getAttribute("content");
            isPaged = mode === "paged";
            titleFallback = (headerActions === null || headerActions === void 0 ? void 0 : headerActions.documentTitle) || ((_document$getElementB = document.getElementById("documentTitle")) === null || _document$getElementB === void 0 ? void 0 : _document$getElementB.value) || "Document";
            _context9.prev = 5;
            showToast(isPaged ? "Generating page-wise PDF..." : "Generating single-page PDF...");
            _context9.next = 9;
            return axios.post("/builder/download-pdf", {
              html: rawHtml,
              mode: mode,
              title: titleFallback
            }, {
              headers: _objectSpread({
                "Content-Type": "application/json",
                "Accept": "application/pdf"
              }, csrfToken ? {
                "X-CSRF-TOKEN": csrfToken
              } : {}),
              responseType: "blob"
            });
          case 9:
            response = _context9.sent;
            blob = new Blob([response.data], {
              type: "application/pdf"
            });
            url = URL.createObjectURL(blob);
            a = document.createElement("a");
            a.href = url;
            a.download = filenameFromContentDisposition((_response$headers = response.headers) === null || _response$headers === void 0 ? void 0 : _response$headers["content-disposition"], mode, titleFallback) || buildPdfFilename(titleFallback, mode);
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            URL.revokeObjectURL(url);
            showToast(isPaged ? "Page-wise PDF downloaded successfully!" : "Single-page PDF downloaded successfully!");
            _context9.next = 45;
            break;
          case 22:
            _context9.prev = 22;
            _context9.t0 = _context9["catch"](5);
            message = "PDF generation failed";
            if (!(((_err$response2 = _context9.t0.response) === null || _err$response2 === void 0 ? void 0 : _err$response2.data) instanceof Blob)) {
              _context9.next = 40;
              break;
            }
            _context9.prev = 26;
            _context9.next = 29;
            return _context9.t0.response.data.text();
          case 29:
            text = _context9.sent;
            json = JSON.parse(text);
            parts = [json.message, json.error].filter(Boolean);
            message = parts.join(": ") || message;
            if (json.details) {
              console.error("PDF download error details:", json.details);
            }
            _context9.next = 38;
            break;
          case 36:
            _context9.prev = 36;
            _context9.t1 = _context9["catch"](26);
          case 38:
            _context9.next = 44;
            break;
          case 40:
            data = (_err$response3 = _context9.t0.response) === null || _err$response3 === void 0 ? void 0 : _err$response3.data;
            _parts = [data === null || data === void 0 ? void 0 : data.message, data === null || data === void 0 ? void 0 : data.error].filter(Boolean);
            message = _parts.join(": ") || message;
            if (data !== null && data !== void 0 && data.details) {
              console.error("PDF download error details:", data.details);
            }
          case 44:
            showToast(message);
          case 45:
          case "end":
            return _context9.stop();
        }
      }, _callee9, null, [[5, 22], [26, 36]]);
    }));
    return _requestPdfDownload.apply(this, arguments);
  }
  function downloadPdfFile() {
    return requestPdfDownload("single");
  }
  function downloadPagedPdfFile() {
    return requestPdfDownload("paged");
  }
  var activeNode = findNodeRecursive(page.tree, selected);
  var activeBlockStyle = activeNode ? _objectSpread(_objectSpread({}, activeNode.style || {}), viewport === "desktop" ? {} : ((_activeNode$responsiv = activeNode.responsiveStyles) === null || _activeNode$responsiv === void 0 ? void 0 : _activeNode$responsiv[viewport]) || {}) : undefined;
  var active = activeNode ? _objectSpread(_objectSpread({}, activeNode), {}, {
    style: activeBlockStyle
  }) : null;
  var activeStyle = activeNode && selectedElement ? _objectSpread(_objectSpread(_objectSpread({}, activeBlockStyle), ((_activeNode$elementSt = activeNode.elementStyles) === null || _activeNode$elementSt === void 0 ? void 0 : _activeNode$elementSt[selectedElement]) || {}), viewport === "desktop" ? {} : ((_activeNode$responsiv2 = activeNode.responsiveElementStyles) === null || _activeNode$responsiv2 === void 0 || (_activeNode$responsiv2 = _activeNode$responsiv2[viewport]) === null || _activeNode$responsiv2 === void 0 ? void 0 : _activeNode$responsiv2[selectedElement]) || {}) : activeBlockStyle;
  return /*#__PURE__*/_jsxs("div", {
    style: {
      display: "flex",
      flexDirection: "column",
      height: height,
      background: UI.shell,
      color: UI.text,
      fontFamily: DEFAULT_FONT,
      overflow: "hidden",
      position: "relative"
    },
    children: [toast.show && /*#__PURE__*/_jsxs("div", {
      style: {
        position: "absolute",
        top: 70,
        left: "50%",
        transform: "translateX(-50%)",
        background: '#10b981',
        borderRadius: 8,
        padding: "9px 20px",
        color: "#ffffff",
        fontWeight: 600,
        fontSize: 12,
        boxShadow: UI.shadowMd,
        zIndex: 9999,
        display: "flex",
        alignItems: "center",
        gap: 10,
        animation: "slideDown 0.3s ease"
      },
      children: [/*#__PURE__*/_jsx(BuilderIcon, {
        name: "ai",
        size: 18,
        color: UI.accent
      }), toast.message]
    }), /*#__PURE__*/_jsx(Toolbar, {
      viewport: viewport,
      setViewport: setViewport,
      undo: undo,
      redo: redo,
      history: history,
      future: future,
      downloadPdfFile: downloadPdfFile,
      downloadPagedPdfFile: downloadPagedPdfFile,
      clearCanvas: clearCanvas,
      onSave: onSave,
      page: page,
      showToast: showToast,
      triggerConfirm: triggerConfirm,
      standalone: standalone,
      headerActions: headerActions
    }), /*#__PURE__*/_jsxs("div", {
      style: {
        display: "flex",
        flex: 1,
        overflow: "hidden",
        position: "relative",
        minWidth: 0
      },
      children: [/*#__PURE__*/_jsx(Sidebar, {
        activeLeftTab: activeLeftTab,
        setActiveLeftTab: setActiveLeftTab,
        add: add,
        handleDragStartSidebar: handleDragStartSidebar,
        addSection: addSection,
        aiProvider: aiProvider,
        setAiProvider: handleAiProviderChange,
        aiKeys: aiKeys,
        setAiKeys: setAiKeys,
        onAiKeyChange: handleAiKeyChange,
        aiPrompt: aiPrompt,
        setAiPrompt: setAiPrompt,
        aiLoading: aiLoading,
        handleAiGenerate: handleAiGenerate,
        aiResult: aiResult,
        change: change,
        page: page,
        showToast: showToast,
        selected: selected,
        selectBlock: selectBlock,
        toggleBlockLock: toggleBlockLock,
        moveBlockTo: moveBlockTo,
        isCompact: isCompact,
        panelWidth: leftSidebarWidth,
        isExpanded: !isCompact || leftPanelExpanded,
        onExpand: function onExpand() {
          setLeftPanelExpanded(true);
          setRightPanelExpanded(false);
        },
        onCollapse: function onCollapse() {
          return setLeftPanelExpanded(false);
        }
      }), /*#__PURE__*/_jsx(Canvas, {
        viewport: viewport,
        page: page,
        selected: selected,
        selectedElement: selectedElement,
        selectBlock: selectBlock,
        selectElement: selectElement,
        dragSourceRef: dragSourceRef,
        dragOverPos: dragOverPos,
        setDragOverPos: setDropPosition,
        isDragActive: isDragActive,
        handleDropCanvasBg: handleDropCanvasBg,
        handleDragOverCanvas: handleDragOverCanvas,
        handleDropCanvas: handleDropCanvas,
        handleDragStartCanvas: handleDragStartCanvas,
        copy: copy,
        paste: paste,
        canPaste: Boolean(copyData),
        duplicate: duplicate,
        moveBlockUp: moveBlockUp,
        moveBlockDown: moveBlockDown,
        moveBlockOutOfColumn: moveBlockOutOfColumn,
        remove: remove,
        ungroup: ungroup,
        toggleBlockLock: toggleBlockLock,
        signBlockSide: signBlockSide,
        getActiveFontFamily: getActiveFontFamily,
        globalBackgroundColor: globalBackgroundColor,
        globalBackgroundImage: globalBackgroundImage,
        getActiveTextColor: getActiveTextColor,
        documentPadding: documentPadding,
        documentPageSize: documentPageSize,
        showSafeArea: showSafeArea,
        showGrid: showGrid,
        editTableHeader: editTableHeader,
        editTableCell: editTableCell,
        editText: editText,
        editCardTitle: editCardTitle,
        editListItem: editListItem,
        editTwoColumnLeft: editTwoColumnLeft,
        editTwoColumnRight: editTwoColumnRight,
        editThreeColumn: editThreeColumn,
        editContentField: editContentField,
        editAccordionItem: editAccordionItem,
        editPricingPlan: editPricingPlan,
        editPricingFeature: editPricingFeature,
        editTestimonial: editTestimonial,
        editTimelineItem: editTimelineItem,
        mentionConfig: mentionConfig
      }), /*#__PURE__*/_jsx(PropertiesPanel, {
        viewport: viewport,
        active: active,
        activeStyle: activeStyle,
        selectedElement: selectedElement,
        activeRightTab: activeRightTab,
        setActiveRightTab: setActiveRightTab,
        editText: editText,
        editHeadingTag: editHeadingTag,
        editCardTitle: editCardTitle,
        editButtonLink: editButtonLink,
        editButtonTarget: editButtonTarget,
        editImageSrc: editImageSrc,
        editImageAlt: editImageAlt,
        editImageLink: editImageLink,
        editHtmlCode: editHtmlCode,
        editListItem: editListItem,
        removeListItem: removeListItem,
        addListItem: addListItem,
        editSocialLink: editSocialLink,
        editTwoColumnLeft: editTwoColumnLeft,
        editTwoColumnRight: editTwoColumnRight,
        editThreeColumn: editThreeColumn,
        editContentField: editContentField,
        editIconBlock: editIconBlock,
        removeGalleryImage: removeGalleryImage,
        editGalleryImage: editGalleryImage,
        handleGalleryImageUpload: handleGalleryImageUpload,
        addGalleryImage: addGalleryImage,
        removeLogo: removeLogo,
        editLogo: editLogo,
        handleLogoImageUpload: handleLogoImageUpload,
        addLogo: addLogo,
        removeAccordionItem: removeAccordionItem,
        editAccordionItem: editAccordionItem,
        addAccordionItem: addAccordionItem,
        removePricingPlan: removePricingPlan,
        editPricingPlan: editPricingPlan,
        editPricingFeature: editPricingFeature,
        removePricingFeature: removePricingFeature,
        addPricingFeature: addPricingFeature,
        addPricingPlan: addPricingPlan,
        removeTestimonial: removeTestimonial,
        editTestimonial: editTestimonial,
        addTestimonial: addTestimonial,
        handleTestimonialAvatarUpload: handleTestimonialAvatarUpload,
        removeTimelineItem: removeTimelineItem,
        editTimelineItem: editTimelineItem,
        addTimelineItem: addTimelineItem,
        duplicateTimelineItem: duplicateTimelineItem,
        editTableHeader: editTableHeader,
        editTableCell: editTableCell,
        duplicateTableRow: duplicateTableRow,
        removeTableRow: removeTableRow,
        removeTableColumn: removeTableColumn,
        addTableRow: addTableRow,
        addTableColumn: addTableColumn,
        addLayoutColumn: addLayoutColumn,
        duplicateLayoutColumn: duplicateLayoutColumn,
        removeLayoutColumn: removeLayoutColumn,
        css: css,
        applyStylePatch: applyStylePatch,
        updateSpacing: updateSpacing,
        updateSpacingAll: updateSpacingAll,
        toggleSpacingMode: toggleSpacingMode,
        updateSize: updateSize,
        updateOffset: updateOffset,
        updatePosition: updatePosition,
        updateZIndex: updateZIndex,
        resetResponsiveStyles: resetResponsiveStyles,
        updateRadiusCorner: updateRadiusCorner,
        updateRadiusAll: updateRadiusAll,
        toggleRadiusMode: toggleRadiusMode,
        updateColumnBackground: updateColumnBackground,
        updateColumnStyleValue: updateColumnStyleValue,
        updateColumnStyleValues: updateColumnStyleValues,
        updateImageShape: updateImageShape,
        remove: remove,
        getActiveFontFamily: getActiveFontFamily,
        getActiveTextColor: getActiveTextColor,
        handleFontChange: handleFontChange,
        applyGlobalTextColor: applyGlobalTextColor,
        getActiveButtonBackgroundColor: getActiveButtonBackgroundColor,
        getActiveButtonTextColor: getActiveButtonTextColor,
        applyGlobalButtonBackgroundColor: applyGlobalButtonBackgroundColor,
        applyGlobalButtonTextColor: applyGlobalButtonTextColor,
        getActiveBackgroundColor: getActiveBackgroundColor,
        applyGlobalBackgroundColor: applyGlobalBackgroundColor,
        getActiveBackgroundImage: getActiveBackgroundImage,
        setGlobalBackgroundImageUrl: setGlobalBackgroundImageUrl,
        handleGlobalBackgroundImageUpload: handleGlobalBackgroundImageUpload,
        documentPadding: documentPadding,
        setDocumentPadding: setDocumentPadding,
        documentPageSize: documentPageSize,
        setDocumentPageSize: setDocumentPageSize,
        showSafeArea: showSafeArea,
        setShowSafeArea: setShowSafeArea,
        showGrid: showGrid,
        setShowGrid: setShowGrid,
        handleBackgroundImageUpload: handleBackgroundImageUpload,
        setBackgroundImageUrl: setBackgroundImageUrl,
        imageUploading: imageUploading,
        imageUploadError: imageUploadError,
        handleImageSrcUpload: handleImageSrcUpload,
        showSavedTemplates: showSavedTemplates,
        savedTemplates: savedTemplates,
        savedTemplatesLoading: savedTemplatesLoading,
        onSelectSavedTemplate: applySavedDocumentTemplate,
        isCompact: isCompact,
        panelWidth: sidePanelWidth,
        isExpanded: !isCompact || rightPanelExpanded,
        onExpand: function onExpand() {
          setRightPanelExpanded(true);
          setLeftPanelExpanded(false);
        },
        onCollapse: function onCollapse() {
          return setRightPanelExpanded(false);
        }
      })]
    }), customConfirm.isOpen && /*#__PURE__*/_jsx("div", {
      className: "modal fade show confimation-modal",
      style: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        position: "fixed",
        inset: 0,
        zIndex: 99999,
        backgroundColor: "rgba(16, 24, 40, 0.5)"
      },
      role: "dialog",
      "aria-modal": "true",
      onClick: customConfirm.onCancel,
      children: /*#__PURE__*/_jsx("div", {
        className: "modal-dialog modal-dialog-centered modal-xs",
        style: {
          margin: 16,
          width: "100%",
          maxWidth: 400
        },
        onClick: function onClick(e) {
          return e.stopPropagation();
        },
        children: /*#__PURE__*/_jsxs("div", {
          className: "modal-content",
          style: {
            position: "relative",
            border: "none",
            borderRadius: 12,
            overflow: "hidden",
            boxShadow: "0 20px 24px -4px rgba(16, 24, 40, 0.08), 0 8px 8px -4px rgba(16, 24, 40, 0.03)"
          },
          children: [/*#__PURE__*/_jsx("button", {
            type: "button",
            className: "button button-icon button-icon-lg button-transparent-light close",
            "aria-label": "Close",
            onClick: customConfirm.onCancel,
            style: {
              position: "absolute",
              top: 12,
              right: 12,
              zIndex: 1,
              background: "transparent",
              border: "none",
              cursor: "pointer",
              padding: 4,
              color: "#667085"
            },
            children: /*#__PURE__*/_jsx("span", {
              className: "icon",
              style: {
                fontSize: 24,
                display: "block"
              },
              children: /*#__PURE__*/_jsx("svg", {
                width: "24",
                height: "25",
                viewBox: "0 0 24 25",
                fill: "none",
                stroke: "currentColor",
                xmlns: "http://www.w3.org/2000/svg",
                children: /*#__PURE__*/_jsx("path", {
                  d: "M18 6.5L6 18.5M6 6.5L18 18.5",
                  strokeWidth: "2",
                  strokeLinecap: "round",
                  strokeLinejoin: "round"
                })
              })
            })
          }), /*#__PURE__*/_jsx("div", {
            className: "modal-body",
            style: {
              padding: "24px 24px 8px"
            },
            children: /*#__PURE__*/_jsxs("div", {
              className: "confirmation-content",
              children: [/*#__PURE__*/_jsx("div", {
                className: "row justify-center",
                style: {
                  display: "flex",
                  justifyContent: "center"
                },
                children: /*#__PURE__*/_jsx("div", {
                  className: "col-initial",
                  children: /*#__PURE__*/_jsx("div", {
                    className: "icon icon-circle icon-circle-error",
                    style: {
                      width: 48,
                      height: 48,
                      borderRadius: "50%",
                      background: "rgba(217, 45, 32, 0.2)",
                      color: "#D92D20",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      margin: "0 auto"
                    },
                    children: /*#__PURE__*/_jsxs("svg", {
                      width: "24",
                      height: "24",
                      viewBox: "0 0 24 24",
                      fill: "none",
                      stroke: "currentColor",
                      xmlns: "http://www.w3.org/2000/svg",
                      children: [/*#__PURE__*/_jsx("circle", {
                        cx: "12",
                        cy: "12",
                        r: "10",
                        strokeWidth: "1.5"
                      }), /*#__PURE__*/_jsx("path", {
                        d: "M12 8v4",
                        strokeWidth: "1.5",
                        strokeLinecap: "round"
                      }), /*#__PURE__*/_jsx("circle", {
                        cx: "12",
                        cy: "16",
                        r: "0.75",
                        fill: "currentColor",
                        stroke: "none"
                      })]
                    })
                  })
                })
              }), /*#__PURE__*/_jsx("h4", {
                className: "text-center text-xl font-medium",
                style: {
                  marginTop: 16,
                  marginBottom: 4,
                  textAlign: "center",
                  fontSize: 20,
                  fontWeight: 500,
                  color: "#101828"
                },
                children: customConfirm.title
              }), /*#__PURE__*/_jsx("p", {
                className: "text-center",
                style: {
                  textAlign: "center",
                  margin: 0,
                  color: "#475467",
                  fontSize: 14,
                  lineHeight: 1.5
                },
                children: customConfirm.message
              })]
            })
          }), /*#__PURE__*/_jsx("div", {
            className: "modal-footer",
            style: {
              border: "none",
              padding: "16px 24px 24px",
              display: "block"
            },
            children: /*#__PURE__*/_jsxs("div", {
              className: "row gutter-8",
              style: {
                display: "flex",
                gap: 8
              },
              children: [/*#__PURE__*/_jsx("div", {
                className: "col-6",
                style: {
                  flex: 1
                },
                children: /*#__PURE__*/_jsx("button", {
                  type: "button",
                  className: "button button-pill button-full button-default",
                  onClick: customConfirm.onCancel,
                  style: {
                    width: "100%"
                  },
                  children: customConfirm.cancelLabel
                })
              }), /*#__PURE__*/_jsx("div", {
                className: "col-6",
                style: {
                  flex: 1
                },
                children: /*#__PURE__*/_jsx("button", {
                  type: "button",
                  className: "button button-pill button-full button-primary",
                  onClick: customConfirm.onConfirm,
                  style: {
                    width: "100%"
                  },
                  children: customConfirm.confirmLabel
                })
              })]
            })
          })]
        })
      })
    })]
  });
}